import React, {
    useState,
    useEffect,
    useRef,
    useMemo,
    useCallback,
} from "react";
import { AgGridReact } from "ag-grid-react";
import axios from "axios";
import { Tag, message, Button, Input } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import "ag-grid-enterprise/styles/ag-theme-alpine.css";
import "ag-grid-enterprise/styles/ag-grid.css";
import "ag-grid-enterprise/styles/ag-theme-quartz.css";
import { ClipLoader } from "react-spinners";
import "../App.css";
import EmailModal from "../EmailModel/EmailModel";
import { useRecoilState } from "recoil";
import { workspaceInfo } from "app/config/States/users";
import EmailConfirmationModel from "../EmailConfirmation/EmailConfirmation";
import MainContentVendor from "../VendorScore/pages/demo/MainContent/MainContent";
import { API_ENDPOINT_GET_USER_INFO } from "app/scenes/Auth/auth.constants";
import { apiGet, apiPost } from "app/services/apiServices";
import UploadContactsModal from "../UploadContactModel/UploadContactsModal";
import w from "app/shared/AgTable/AgTableClient/w";
import Modal from "react-modal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import invoicepng from "../../../../assets/images/image copy.png";
import ContactPopup from "../Popup/ContactPopup";
import AccessDeniedModal from "../AccessDeniedModal/AcessDenied";
import {
    CopyOutlined,
    PlusOutlined,
    CheckCircleFilled,
    CloseCircleOutlined,
    CloseOutlined,
    CloseCircleFilled
} from "@ant-design/icons";
import ConfirmationPopup from "../Confirmation/ConfirmationPopup";
import { FaBan } from "react-icons/fa";
import PrimaryNavBhilosa from "app/shared/PrimaryNavBhilosa";
import { Tabs, Tooltip } from "antd";
import {
    API_ENDPOINT_BHILOSA_VIEWS,
} from "./Trial.constant";
import { tableDynamicViews } from "app/config/States/agtable";
import DraftsOutlinedIcon from "@mui/icons-material/DraftsOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import DoneAllOutlinedIcon from "@mui/icons-material/DoneAllOutlined";
import { colorPicker } from "app/utils/color.helper";
import Typography from "app/shared/Typography";
import { API_ENDPOINT_ADD_CONTACT, API_ENDPOINT_PREVIEW_VENDOR_TALLY, API_ENDPOINT_UNIQUE_VENDOR_TALLY } from "../../vendorfollowup.constants";

const VendorEInvoiceDataNew = () => {
    const [rowData, setRowData] = useState([]);
    const [loading, setLoading] = useState(false);
    const location = useLocation();

    const [contactName, setContactName] = useState("");
    const [contactEmail, setContactEmail] = useState("");
    const [contactNumber, setContactNumber] = useState("");
    const [roleType, setRoleType] = useState("");
    const [contactData, setContactData] = useState([]);
    const [selectedEmail, setSelectedEmail] = useState(null);
    const [SelectedVendor, setSelectedVendor] = useState(null);
    const [IN, setSelectedIN] = useState(null);
    const [ID, setSelectedID] = useState(null);

    const [gridApi, setGridApi] = useState(null);
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const [SelectedGstin, setSelecteGstin] = useState(null);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [filteredOptions, setFilteredOptions] = useState([]);
    const [workspaces, setWorkspaces] = useState([]);
    const [modalVendorData, setModalVendorData] = useState([]); // State to hold the vendor data
    const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState("");
    const [radioValue, setRadioValue] = useState(false);
    const [currentGrouped, setCurrentGrouped] = useState("_id");
    const [currentColumnGrouped, setColumntCurrentGrouped] = useState("");
    // const [userRole, setUserRole] = useRecoilState(roleInfo);
    const userRole = localStorage.getItem("role");
    const [messageApi, contextHolder] = message.useMessage();
    const gridRef = useRef(); //new
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [vendorNames, setVendorNames] = useState([]);
    const [initialColumnState, setInitialColumnState] = useState([]); //new
    const [loadingView, setLoadingView] = useState(false); //new
    const [viewName, setViewName] = useState(""); //new
    const [activeTabView, setActiveTabView] = useState(0);

    const [isModalVisible, setIsModalVisible] = useState(false); //new
    const [tableName, setTableName] = useState(""); //new
    const [requestCount, setRequestCount] = useState(0)
    const [selectedTemplateId, setSelectedTemplateId] = useState(null)
    const queryParams = new URLSearchParams(location.search);
    const isSuccessMetric = queryParams.get("successMetric") === "true";
    console.log(isSuccessMetric, "isSuccessMetric");





    const openEmailModal = (vendorData, selectedTemplateId) => {
        setModalVendorData(vendorData);
        setSelectedTemplateId(selectedTemplateId);
        setIsEmailModalOpen(true);
    };
    const closeEmailModal = () => {
        setIsEmailModalOpen(false);

        gridApi.deselectAll();
    };

    const [isEmailConfirmationModelOpen, setIsEmailConfirmationModelOpen] =
        useState(false);

    const [selectedVendorNamesAndGstin, setSelectedVendorNamesAndGstin] =
        useState([]);

    const handleSendInvite = () => {
        const updatedRows = rowData.map((row) => {
            const vendorName = row.enablement?.legalNm;
            const ctin = row.ctin;

            const vendorMatch = selectedVendorNamesAndGstin.some(
                (vendor) => vendor.vendorName === vendorName && vendor.ctin === ctin
            );
            if (
                vendorMatch &&
                row.followUpStatus !== "Sent" &&
                row.followUpStatus !== "Opened"
            ) {
                return {
                    ...row,
                    followUpStatus: "Sent", // Update the follow-up status
                    Email_logs: [
                        ...(row.Email_logs || []), // Preserve existing events
                        { event: "sent", timestamp: new Date().toISOString() }, // Add the 'sent' event
                    ],
                };
            }
            return row;
        });

        // Update rowData state, this will trigger a re-render of the grid
        setRowData(updatedRows);

        gridApi.deselectAll();

        setIsEmailModalOpen(false);
        setIsEmailConfirmationModelOpen(true);
    };

    const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);
    const [gstin, setGstin] = useState(null); // State to store ctin

    const [workspace, setWorkspace] = useRecoilState(workspaceInfo);
    const workspace_name = localStorage.getItem("name");


    const [selectedWorkspace, setSelectedWorkspace] = useState("");



    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const workspace = urlParams.get("workspace");
        if (workspace) {
            setSelectedWorkspace(workspace);
        }
    }, [location]);


    const [selectedMonth, setSelectedMonth] = useState(null);

    useEffect(() => {
        if (location.state?.selectedMonths) {
            const selectedMonths = location.state.selectedMonths;
            setSelectedMonth(selectedMonths);
        }
    }, [location]);






    const [activeTab, setActiveTab] = useState("All Data");
    const [selectedValue, setSelectedValue] = useState("All Data"); // Default value for Action Required
    const [isPopupVisible, setPopupVisible] = useState(false);

    const handlePopupClose = () => {
        if (!gridApi) {
            console.error("gridApi is not initialized");
            return;
        }
        setPopupVisible(false);
        gridApi.deselectAll();

    };

    const handlePopupConfirm = () => {
        setPopupVisible(false);
        if (selectedVendorData.length > 0) {
            openEmailModal(selectedVendorData, "d-744bd0419cf54c3cac21b81b4731e0cb");
        }
    };

    const handleTabClick = (tabName) => {
        setActiveTab(tabName);
        setSelectedValue(tabName); // Set the selected value based on the clicked tab
    };

    const handleCellClick = (event) => {
        console.log("***********Cell clicked**********");
        console.log(gridApi, "gridApi in handle cell click");

        const selectRow = event.api.getSelectedRows();
        setSelectedRow(selectRow);
        console.log(selectRow, "selected row");

        const { colDef, data, node } = event;


        if (colDef.field === "vendor_data.enablement_gov.tradeName") {
            setSelectedRowId(node.id);

            const ctin = data.vendor_data.vendor_gstin;
            const totalGstAmount = data.Amount_data.totalGstAmount;



            // Calculate invoice data for the selected GSTIN
            const invoiceData = calculateInvoiceData(ctin);
            console.log(invoiceData);

            setGstin(ctin);
            setTotalGstAmount(totalGstAmount);
            setInvoicesData(invoiceData); // Set the calculated data
            setIsSideMenuOpen(true); // Open the side menu

            // navigate(`/vendorfollowup/vendorscore?vendorName=${vendorName}&pan=${pan}&ctin=${ctin}`);
        }

        if (colDef.field === "action") {
            console.log("action clicked");

            const {
                contact,
                einvoiceEligibility,
                ctin,
                enablement,
                invoiceNumber,
                invoiceDate,
                action,
            } = data;

            const legalNm = enablement ? enablement.legalNm : undefined;

            // Only open the modal if action is "Send Mail"
            if (action === "Send Mail") {
                if (contact === "Completed" && einvoiceEligibility === "Eligible") {
                    // Find the email based on GSTIN
                    const contactDetail = contactData.find(
                        (contact) => contact.ctin === ctin
                    );
                    console.log("contactDetails:", contactDetail);

                    if (contactDetail) {
                        setSelectedEmail(contactDetail.contactEmail); // Set email state
                        console.log(legalNm);
                        setSelectedVendor(legalNm);
                        setSelecteGstin(ctin);
                        setSelectedIN(invoiceNumber);
                        setSelectedID(invoiceDate);
                        openEmailModal();
                    } else {
                        console.error("No contact details found for GSTIN:", ctin);
                    }
                }
            } else {
                console.log("Action is not 'Send Mail', modal will not open.");
            }
        }

        if (
            colDef.field === "followUpStatus" &&
            data.followUpStatus === "request"
        ) {
            console.log(data, "data in followupstatus clicked")
            const vendorInfo = {
                vendorName: data.vendor_data.enablement_gov.tradeName,
                vendor_gstin: data.vendor_data.vendor_gstin,
            };

            openEmailModal([vendorInfo], "d-744bd0419cf54c3cac21b81b4731e0cb");
            console.log("followupstatus clicked");
            // openEmailModal();
        }

        if (
            colDef.field === "followUpStatus" &&
            data.followUpStatus === "sent"
        ) {
            console.log(data, "data in followupstatus clicked")
            const vendorInfo = {
                vendorName: data.vendor_data.enablement_gov.tradeName,
                vendor_gstin: data.vendor_data.vendor_gstin,
            };

            // openEmailModal([vendorInfo]);
            openEmailModal([vendorInfo], "d-315b0365c9754a5dbb97449e653f06a1");
            console.log("followupstatus clicked");
            // openEmailModal();
        }
        if (
            colDef.field === "followUpStatus" &&
            data.followUpStatus === "followUp1"
        ) {
            console.log(data, "data in followupstatus clicked")
            const vendorInfo = {
                vendorName: data.vendor_data.enablement_gov.tradeName,
                vendor_gstin: data.vendor_data.vendor_gstin,
            };

            // openEmailModal([vendorInfo]);
            openEmailModal([vendorInfo], "d-cd77675790a943be9b6a834848ca3522");
            console.log("followupstatus clicked");
            // openEmailModal();
        }
        if (
            colDef.field === "followUpStatus" &&
            data.followUpStatus === "followUp2"
        ) {
            console.log(data, "data in followupstatus clicked")
            const vendorInfo = {
                vendorName: data.vendor_data.enablement_gov.tradeName,
                vendor_gstin: data.vendor_data.vendor_gstin,
            };

            // openEmailModal([vendorInfo]);
            openEmailModal([vendorInfo], "d-d-28efe496b27c4943848567ace11566a3");
            console.log("followupstatus clicked");
            // openEmailModal();
        }
        if (
            colDef.field === "followUpStatus" &&
            data.followUpStatus === "followUp3"
        ) {
            console.log(data, "data in followupstatus clicked")
            const vendorInfo = {
                vendorName: data.vendor_data.enablement_gov.tradeName,
                vendor_gstin: data.vendor_data.vendor_gstin,
            };

            // openEmailModal([vendorInfo]);
            openEmailModal([vendorInfo], "d-d-28efe496b27c4943848567ace11566a3");
            console.log("followupstatus clicked");
            // openEmailModal();
        }


        if (
            colDef.field === "followUpStatus" &&
            data.followUpStatus === "Contact Missing"
        ) {
            console.log("followupstatus clicked");

            if (userRole !== "ADMIN") {
                setAccessDeniedModalVisible(true); // Show access denied modal
                return;
            }

            // Ensure enablement exists and access its value
            if (data.vendor_data.enablement_gov && data.vendor_data.enablement_gov.tradeName && data.vendor_data.vendor_gstin) {

                const enablementValue = data.vendor_data.enablement_gov.tradeName; // Access the first value in the enablement array

                setVendorValue(enablementValue); // Set vendor name properly
                setVendorGstin(data.vendor_data.vendor_gstin);
                openModal(); // Open the modal
            } else {
                console.error("Enablement data is missing or empty.");
            }
        }
    };

    useEffect(() => {
        if (gridApi) {
            const datasource = getServerSideDatasource(selectedWorkspace, isSuccessMetric)

            gridApi.setServerSideDatasource(datasource);
            gridApi.refreshCells()
        }
    }, [gridApi, selectedWorkspace, selectedValue, activeTabView, location.search]);


    const [isModalOpen, setIsModalOpen] = useState(false);
    const [vendorValue, setVendorValue] = useState("");
    const [vendorGstin, setVendorGstin] = useState("");

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    // Declare defaultColDef once
    const defaultColDef = {
        filter: "agTextColumnFilter",
        filter: true,
        floatingFilter: true,
        sortable: true,
        resizable: true,
        enableRowGroup: true,
        // floatingFilter: true,

        cellStyle: { textAlign: "center" }, // Align cell values to the center
        headerClass: "header-center", // Apply custom class for headers
    };

    // State code mapping
    const stateMapping = {
        "01": "Jammu & Kashmir",
        "02": "Himachal Pradesh",
        "03": "Punjab",
        "04": "Chandigarh",
        "05": "Uttarakhand",
        "06": "Haryana",
        "07": "Delhi",
        "08": "Rajasthan",
        "09": "Uttar Pradesh",
        "10": "Bihar",
        "11": "Sikkim",
        "12": "Arunachal Pradesh",
        "13": "Nagaland",
        "14": "Manipur",
        "15": "Mizoram",
        "16": "Tripura",
        "17": "Meghalaya",
        "18": "Assam",
        "19": "West Bengal",
        "20": "Jharkhand",
        "21": "Odisha",
        "22": "Chhattisgarh",
        "23": "Madhya Pradesh",
        "24": "Gujarat",
        "25": "Daman & Diu",
        "26": "Dadra & Nagar Haveli",
        "27": "Maharashtra",
        "28": "Andhra Pradesh",
        "29": "Karnataka",
        "30": "Goa",
        "31": "Lakshadweep",
        "32": "Kerala",
        "33": "Tamil Nadu",
        "34": "Puducherry",
        "35": "Andaman & Nicobar Islands",
        "36": "Telangana",
        "37": "Andhra Pradesh (New)",
    };


    const colorOfEmailEvent = {
        processed: colorPicker("primary.700"),
        delivered: colorPicker("primary.700"),
        open: colorPicker("primary.700"),
        click: colorPicker("primary.700"),
        bounce: "#e74c3c",
        dropped: "#e74c3c",
        spammed: "#e74c3c",
        deffered: "#e74c3c",
    };
    const EVENT_ICON_MAP = {
        processed: (color) => (
            <CheckOutlinedIcon
                style={{
                    fontSize: 18,
                    color: color,
                    cursor: "pointer",
                }}
            />
        ),
        delivered: (color) => (
            <DoneAllOutlinedIcon
                style={{
                    fontSize: 18,
                    color: color,
                    cursor: "pointer",
                }}
            />
        ),
        open: (color) => (
            <DraftsOutlinedIcon
                style={{
                    fontSize: 18,
                    color: color,
                    cursor: "pointer",
                }}
            />
        ),


        bounce: (color) => (
            <CancelOutlinedIcon
                style={{
                    fontSize: 18,
                    color: color,
                    cursor: "pointer",
                }}
            />
        ),


    };
    const mapEmailEvents = (data) => {
        return {
            processed: data?.email_processed === "YES" ? [{ email: "Processed" }] : [],
            delivered: data?.email_delivered === "YES" ? [{ email: "Delivered" }] : [],
            open: data?.email_open === "YES" ? [{ email: "Opened" }] : [],
            bounce: data?.email_bounce === "YES" ? [{ email: "Bounced" }] : [],
            dropped: data?.email_dropped === "YES" ? [{ email: "Dropped" }] : [],
        };
    };

    const handleRenderEmailEvents = (eventData) => {
        return (
            <div
                style={{
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                }}
            >
                {Object.entries(EVENT_ICON_MAP).map((emailEvent) => {
                    const readers = eventData?.[emailEvent[0]] || [];

                    return (
                        <div
                            key={emailEvent[0]}
                            style={{
                                marginRight: 6,
                                display: "flex",
                                height: "100%",
                                alignItems: "center",
                            }}
                        >
                            <Tooltip
                                placement="bottom"
                                title={
                                    <div>
                                        <Typography
                                            style={{ color: "white", marginBottom: 12 }}
                                            variant="xs"
                                        >
                                            {emailEvent[0]}
                                        </Typography>

                                        {/* Full list of emails and timestamps */}
                                        {readers.length > 0 && (
                                            <Tag key={readers[0].email} style={{ fontSize: 10 }}>
                                                {readers[0].email}
                                                {readers.length > 1 && ` +${readers.length - 1} more`}
                                            </Tag>
                                        )}
                                    </div>
                                }
                            >
                                {emailEvent[1](
                                    readers.length > 0
                                        ? colorOfEmailEvent[emailEvent[0]]
                                        : "rgb(192 194 197)"
                                )}
                            </Tooltip>


                        </div>
                    );
                })}
            </div>
        );
    };





    // const renderFollowUp2 = (params) => {
    //     if (params.value === "request") {
    //         return "Yet to be Requested";
    //     }

    //     if (params.value === "sent" && params.data.Email_logs?.length > 0) {
    //         return params.data.Email_logs[0]?.subject || "No Subject available";
    //     }

    //     if (params.value === "followUp1" && params.data.Email_logs?.length > 1) {
    //         return params.data.Email_logs[1]?.subject || "No Subject available";
    //     }
    //     if (params.value === "followUp2" && params.data.Email_logs?.length > 1) {
    //         return params.data.Email_logs[2]?.subject || "No Subject available";
    //     }

    //     return "No data available";
    // };
    const followUpStatusMapping = {
        request: "Yet to be Requested",
        sent: "Mandatory E-Invoicing Compliance Under GST- Vendor Wise",
        followUp1: "Invoice-Wise Follow-Up 1 (Immediate Notification)",
        followUp2: "Invoice-Wise Follow-Up 2 (General Reminder)",
        followUp3: "Invoice-Wise Follow-Up 3 (Final Warning via GST Portal)",
    };
    const renderFollowUp2 = (params) => {
        const followUpStatus = params?.data?.followUpStatus;
      
        if (!followUpStatus) return "No data available";
      
        return followUpStatusMapping[followUpStatus] || "No data available";
      };
      
    function renderFollowUp(params) {
        let textColor = "";
        let icon = null;
        let displayText = params.value;
        let isButton = false;
        const { exemptionStatus, einvoiceEligibility, vendor_data } = params.data || {};


        console.log(params.data, "render followup")

        if (isSuccessMetric) {
            displayText = "No Action Required";
            textColor = "#E26E00";
            icon = <FaBan style={{ color: "#E26E00" }} />;
            return (
                <span
                    style={{
                        color: textColor,
                        fontSize: "12px",
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                    }}
                >
                    {icon} {displayText}
                </span>
            );
        }


        // Override value based on other fields
        if ((exemptionStatus === true || vendor_data?.exemptionStatus === true) && einvoiceEligibility === "Eligible") {
            displayText = "No Action Required";
            textColor = "#E26E00";
            icon = <FaBan style={{ color: "#E26E00" }} />;
            return (
                <span
                    style={{
                        color: textColor,
                        fontSize: "12px",
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                    }}
                >
                    {icon} {displayText}
                </span>
            );
        }


        if (params.value === "request") {
            textColor = "#0A8394";
            displayText = "Request";
            isButton = true;
        } else if (params.value === "Contact Missing") {
            textColor = "red";
        } else if (params.value === "No Action Required") {
            textColor = "#E26E00";
            icon = <FaBan style={{ color: "#E26E00" }} />; // Colored ban icon
        } else if (params.value === "sent") {
            textColor = "green";
            displayText = "Request FollowUp 1";
            icon = "📤";
            isButton = true;
        } else if (params.value === "followUp1") {
            textColor = "green";
            displayText = "Request FollowUp 2";
            icon = "📤";
            isButton = true;
        }
        else if (params.value === "followUp2") {
            textColor = "green";
            displayText = "Email sent";
            icon = "📤";
            // isButton=true;
        }
        else if (params.value === "Opened") {
            textColor = "blue";
            icon = "📖";
        }

        return isButton ? (
            <button
                style={{
                    backgroundColor: "white",
                    color: "#0A8394",
                    border: "none",
                    padding: "3px 10px",
                    fontSize: "12px",
                    cursor: "pointer",
                    border: "1px solid #0A8394",
                    borderColor: "#0A8394",
                    borderRadius: "4px",
                }}
                onClick={() => handleCellClick(params)}
            >
                {displayText}
            </button>
        ) : (
            <span
                style={{
                    color: textColor,
                    fontSize: "12px",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                }}
            >
                {icon} {displayText}
            </span>
        );
    }


    const customCellRendererIRN = (params) => {

        const formatRupee = (value) => {
            if (value === undefined || value === null) return '';

            const roundedValue = Math.round(value); // Round to nearest integer

            const valueString = roundedValue.toString();
            const decimalIndex = valueString.indexOf('.');

            if (decimalIndex !== -1) {
                // Calculate number of decimals in the input
                const decimals = valueString.slice(decimalIndex + 1).length;
                return new Intl.NumberFormat('en-IN', {
                    style: 'currency',
                    currency: 'INR',
                    minimumFractionDigits: decimals,
                    maximumFractionDigits: decimals,
                }).format(roundedValue);
            } else {
                // No decimals in the input, format without decimal places
                return new Intl.NumberFormat('en-IN', {
                    style: 'currency',
                    currency: 'INR',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                }).format(roundedValue);
            }
        };

        const formatWithCommas = (value) => {
            if (value === undefined || value === null) return '';

            const roundedValue = Math.round(value); // Round to nearest integer

            const valueString = roundedValue.toString();
            const decimalIndex = valueString.indexOf('.');

            if (decimalIndex !== -1) {
                // Calculate number of decimals in the input
                const decimals = valueString.slice(decimalIndex + 1).length;
                return new Intl.NumberFormat('en-IN', {
                    minimumFractionDigits: decimals,
                    maximumFractionDigits: decimals,
                }).format(roundedValue);
            } else {
                // No decimals in the input, format without decimal places
                return new Intl.NumberFormat('en-IN', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                }).format(roundedValue);
            }
        };

        const handleFilter = (field, value) => {
            const filterInstance = params.api.getFilterInstance(field);
            if (filterInstance) {
                filterInstance.setModel({ type: 'equals', filter: value });
                params.api.onFilterChanged();
            }
        };

        if (!params.node.group && params.node.level === 0) {
            const childItems = params.data["irn"]?.ItemList || [];



            if (params.colDef.field === "GstRt") {
                const fieldValues = childItems.map(item => item[params.colDef.field]).filter(Boolean);

                if (fieldValues.length === 1) {
                    const value = fieldValues[0];
                    return value === 0 || value === '' ? '' : <Tag color="blue" onClick={() => handleFilter(params.colDef.field, value)}>{value}</Tag>;
                } else if (fieldValues.length > 1) {
                    const uniqueValues = [...new Set(fieldValues)];
                    return uniqueValues.map((value) => (
                        <Tag key={value} color="blue" onClick={() => handleFilter(params.colDef.field, value)}>
                            {value}
                        </Tag>
                    ));
                }
                return '';
            }

            if (params.colDef.field === "MainHsnCode") {
                const fieldValues = childItems.map(item => item[params.colDef.field]).filter(Boolean);

                // Function to format HSN Code (adds space every 2 digits)
                const formatHsnCode = (code) => code.replace(/(.{2})/g, "$1 ").trim();

                if (fieldValues.length === 1) {
                    const value = fieldValues[0];
                    return value === 0 || value === '' ? '' : (
                        <Tag color="blue" onClick={() => handleFilter(params.colDef.field, value)}>
                            {formatHsnCode(value)}
                        </Tag>
                    );
                } else if (fieldValues.length > 1) {
                    const uniqueValues = [...new Set(fieldValues)];
                    return uniqueValues.map((value) => (
                        <Tag key={value} color="blue" onClick={() => handleFilter(params.colDef.field, value)}>
                            {formatHsnCode(value)}
                        </Tag>
                    ));
                }
                return '';
            }


            if (params.colDef.field === "HsnCd") {
                const fieldValues = [...new Set(
                    childItems
                        .map(item => item[params.colDef.field])
                        .filter(value => value !== undefined && value !== null && value !== '')
                )]; // Ensuring unique, valid values

                if (fieldValues.length > 0) {
                    return fieldValues.map(value => {
                        let color = "red"; // Default Red for 4-digit
                        if (value.length === 6) color = "blue"; // Blue for 6-digit
                        else if (value.length === 8) color = "orange"; // Orange for 8-digit

                        // Format HSN Code (adding space every 2 digits)
                        const formattedValue = value.replace(/(.{2})/g, "$1 ");

                        return (
                            <Tag
                                key={value}
                                color={color}
                                // style={{
                                //     //fontSize: "3px",
                                //     fontWeight: "bold",
                                //     cursor: "pointer",
                                //     //padding: "1px 6px",  // Adjust padding for better UI
                                //     //borderRadius: "4px",
                                //     //whiteSpace: "nowrap",
                                // }}
                                onClick={() => handleFilter(params.colDef.field, value)}
                            >
                                {formattedValue.trim()}
                            </Tag>
                        );
                    });
                }
                return '';
            }






            //   const fieldValues = childItems.map(item => item[params.colDef.field]).filter(Boolean);

            //   if (fieldValues.length === 1) {
            //     const value = fieldValues[0];
            //     return value === 0 || value === '' ? '' : <strong>{formatRupee(value)}</strong>;
            //   } else if (fieldValues.length > 1) {
            //     const sum = fieldValues.reduce((acc, curr) => acc + (parseFloat(curr) || 0), 0);
            //     return sum === 0 ? '' : <strong>{formatRupee(sum)}</strong>;
            //   }

            //   return '0';
            // }

            const fieldValues = childItems.map(item => item[params.colDef.field]).filter(Boolean);

            if (fieldValues.length === 1) {
                const value = fieldValues[0];
                return value === 0 || value === '' ? '' : <strong>{formatWithCommas(value)}</strong>;
            } else if (fieldValues.length > 1) {
                const sum = fieldValues.reduce((acc, curr) => acc + (parseFloat(curr) || 0), 0);
                return sum === 0 ? '' : <strong>{formatWithCommas(sum)}</strong>;
            }

            return '0';
        }


        if (!params.node.group) {
            const groupData = params.node.groupData["ag-Grid-AutoColumn"];

            if (/^[a-f0-9]{24}$/i.test(groupData)) {
                const childItems = params.data["irn"]?.ItemList || [];

                if (params.colDef.field === "GstRt") {
                    const fieldValues = childItems.map(item => item[params.colDef.field]).filter(Boolean);

                    if (fieldValues.length === 1) {
                        const value = fieldValues[0];
                        return value === 0 || value === '' ? '' : <Tag color="blue" onClick={() => handleFilter(params.colDef.field, value)}>{value}</Tag>;
                    } else if (fieldValues.length > 1) {
                        const uniqueValues = [...new Set(fieldValues)];
                        return uniqueValues.map((value) => (
                            <Tag key={value} color="blue" onClick={() => handleFilter(params.colDef.field, value)}>
                                {value}
                            </Tag>
                        ));
                    }
                    return '';
                }

                // if (params.colDef.field === "HsnCd" || params.colDef.field === "MainHsnCode") {
                //   const fieldValues = childItems.map(item => item[params.colDef.field]).filter(Boolean);

                //   if (fieldValues.length === 1) {
                //     const value = fieldValues[0];
                //     return value === 0 || value === '' ? '' : <Tag color="blue" onClick={() => handleFilter(params.colDef.field, value)}>{value}</Tag>;
                //   } else if (fieldValues.length > 1) {
                //     const uniqueValues = [...new Set(fieldValues)];
                //     return uniqueValues.map((value) => (
                //       <Tag key={value} color="blue" onClick={() => handleFilter(params.colDef.field, value)}>
                //         {value}
                //       </Tag>
                //     ));
                //   }

                //   return '';
                // }

                if (params.colDef.field === "MainHsnCode") {
                    const fieldValues = childItems.map(item => item[params.colDef.field]).filter(Boolean);

                    // Function to format HSN Code (adds space every 2 digits)
                    const formatHsnCode = (code) => code.replace(/(.{2})/g, "$1 ").trim();

                    if (fieldValues.length === 1) {
                        const value = fieldValues[0];
                        return value === 0 || value === '' ? '' : (
                            <Tag color="blue" onClick={() => handleFilter(params.colDef.field, value)}>
                                {formatHsnCode(value)}
                            </Tag>
                        );
                    } else if (fieldValues.length > 1) {
                        const uniqueValues = [...new Set(fieldValues)];
                        return uniqueValues.map((value) => (
                            <Tag key={value} color="blue" onClick={() => handleFilter(params.colDef.field, value)}>
                                {formatHsnCode(value)}
                            </Tag>
                        ));
                    }
                    return '';
                }


                if (params.colDef.field === "HsnCd") {
                    const fieldValues = [...new Set(
                        childItems
                            .map(item => item[params.colDef.field])
                            .filter(value => value !== undefined && value !== null && value !== '')
                    )]; // Ensuring unique, valid values

                    if (fieldValues.length > 0) {
                        return fieldValues.map(value => {
                            let color = "red"; // Default Red for 4-digit
                            if (value.length === 6) color = "blue"; // Blue for 6-digit
                            else if (value.length === 8) color = "orange"; // Orange for 8-digit

                            // Format HSN Code (adding space every 2 digits)
                            const formattedValue = value.replace(/(.{2})/g, "$1 ");

                            return (
                                <Tag
                                    key={value}
                                    color={color}
                                    style={{
                                        fontSize: "3px",
                                        fontWeight: "bold",
                                        cursor: "pointer",
                                        padding: "1px 6px",  // Adjust padding for better UI
                                        borderRadius: "4px",
                                        whiteSpace: "nowrap",
                                    }}
                                    onClick={() => handleFilter(params.colDef.field, value)}
                                >
                                    {formattedValue.trim()}
                                </Tag>
                            );
                        });
                    }
                    return '';
                }

                const fieldValues = childItems.map(item => item[params.colDef.field]).filter(Boolean);

                // if (fieldValues.length === 1) {
                //   const value = fieldValues[0];
                //   return value === 0 || value === '' ? '' : <strong>{formatRupee(value)}</strong>;
                // } else if (fieldValues.length > 1) {
                //   const sum = fieldValues.reduce((acc, curr) => acc + (parseFloat(curr) || 0), 0);
                //   return sum === 0 ? '' : <strong>{formatRupee(sum)}</strong>;
                // }

                // return '';

                if (fieldValues.length === 1) {
                    const value = fieldValues[0];
                    return value === 0 || value === '' ? '' : <strong>{formatWithCommas(value)}</strong>;
                } else if (fieldValues.length > 1) {
                    const sum = fieldValues.reduce((acc, curr) => acc + (parseFloat(curr) || 0), 0);
                    return sum === 0 ? '' : <strong>{formatWithCommas(sum)}</strong>;
                }

                return '';

            }
        }

        //   return (params.colDef.field === "HsnCd" || params.colDef.field === "MainHsnCode")
        //     ? params.value
        //     : (params.colDef.field === "GstRt"
        //       ? (params.value === 0 || params.value === '' || params.value === null ? '' : `${params.value}%`)
        //       : (params.value === 0 || params.value === '' || params.value === null ? '' : formatWithCommas(params.value)));
        //
        return (params.colDef.field === "HsnCd" || params.colDef.field === "MainHsnCode")
            ? params.value
            : (params.value === 0 || params.value === '' ? '' : formatWithCommas(params.value));
    };


    const customCellRenderer = (params) => {
        console.log('params', params);
        console.log('params.node.level', params.node.level);

        // Function to format numbers as rupee currency (rounded off to the nearest integer)
        const formatRupee = (value) => {
            if (value === undefined || value === null) return '';

            return new Intl.NumberFormat('en-IN', {
                style: 'currency',
                currency: 'INR',
                minimumFractionDigits: 0, // No decimal places
                maximumFractionDigits: 0
            }).format(Math.round(value)); // Round the value
        };

        // Function to format numbers with commas (rounded off to the nearest integer)
        const formatWithCommas = (value) => {
            if (value === undefined || value === null) return '';

            return new Intl.NumberFormat('en-IN', {
                minimumFractionDigits: 0, // No decimal places
                maximumFractionDigits: 0
            }).format(Math.round(value)); // Round the value
        };

        if (!params.node.group && params.node.level === 0) {
            const childItems = params.data["twoa"]?.itms || [];
            const mappedValues = childItems.map(item => {
                const itmDet = item.itm_det || {};
                return itmDet[params.colDef.field];
            }).filter(Boolean);

            if (params.colDef.field === 'rt') {
                const uniqueValues = [...new Set(mappedValues)];
                if (uniqueValues.length === 1) {
                    const value = uniqueValues[0];
                    return value === 0 ? '' : <Tag color="green" onClick={() => {
                        params.api.getFilterInstance('rt', (filterInstance) => {
                            filterInstance.setModel({ type: 'equals', filter: value });
                            params.api.onFilterChanged();
                        });
                    }}>{`${value}`}</Tag>;
                } else if (uniqueValues.length > 1) {
                    return uniqueValues.map((value) => (
                        <Tag key={value} color="green" onClick={() => {
                            params.api.getFilterInstance('rt', (filterInstance) => {
                                filterInstance.setModel({ type: 'equals', filter: value });
                                params.api.onFilterChanged();
                            });
                        }}>{`${value}`}</Tag>
                    ));
                } else {
                    return '';
                }
                // } else {
                //   if (mappedValues.length === 1) {
                //     return <strong>{formatRupee(mappedValues[0])}</strong>;
                //   } else if (mappedValues.length > 1) {
                //     const sum = mappedValues.reduce((acc, val) => acc + (Number(val) || 0), 0);
                //     return <strong>{formatRupee(sum)}</strong>;
                //   } else {
                //     return '0';
                //   }
                // }
            } else {
                if (mappedValues.length === 1) {
                    return <strong>{formatWithCommas(mappedValues[0])}</strong>;
                } else if (mappedValues.length > 1) {
                    const sum = mappedValues.reduce((acc, val) => acc + (Number(val) || 0), 0);
                    return <strong>{formatWithCommas(sum)}</strong>;
                } else {
                    return '0';
                }
            }
        }

        if (!params.node.group) {
            const groupData = params.node.groupData["ag-Grid-AutoColumn"];

            if (/^[a-f0-9]{24}$/i.test(groupData)) {
                const childItems = params.data["twoa"]?.itms || [];
                const mappedValues = childItems.map(item => {
                    const itmDet = item.itm_det || {};
                    return itmDet[params.colDef.field];
                }).filter(Boolean);

                if (params.colDef.field === 'rt') {
                    const uniqueValues = [...new Set(mappedValues)];
                    if (uniqueValues.length === 1) {
                        const value = uniqueValues[0];
                        return value === 0 || value === '' ? '' : <Tag color="green" onClick={() => {
                            params.api.getFilterInstance('rt', (filterInstance) => {
                                filterInstance.setModel({ type: 'equals', filter: value });
                                params.api.onFilterChanged();
                            });
                        }}>{`${value}`}</Tag>;
                    } else if (uniqueValues.length > 1) {
                        return uniqueValues.map((value) => (
                            <Tag key={value} color="green" onClick={() => {
                                params.api.getFilterInstance('rt', (filterInstance) => {
                                    filterInstance.setModel({ type: 'equals', filter: value });
                                    params.api.onFilterChanged();
                                });
                            }}>{`${value}`}</Tag>
                        ));
                    } else {
                        return '';
                    }
                }
                // else {
                //   if (mappedValues.length === 1) {
                //     const value = mappedValues[0];
                //     return value === 0 || value === '' ? '' : <strong>{formatRupee(value)}</strong>;
                //   } else if (mappedValues.length > 1) {
                //     const sum = mappedValues.reduce((acc, val) => acc + (Number(val) || 0), 0);
                //     return sum === 0 ? '' : <strong>{formatRupee(sum)}</strong>;
                //   } else {
                //     return '0';
                //   }
                // }
                else {
                    if (mappedValues.length === 1) {
                        const value = mappedValues[0];
                        return value === 0 || value === '' ? '' : <strong>{formatWithCommas(value)}</strong>;
                    } else if (mappedValues.length > 1) {
                        const sum = mappedValues.reduce((acc, val) => acc + (Number(val) || 0), 0);
                        return sum === 0 ? '' : <strong>{formatWithCommas(sum)}</strong>;
                    } else {
                        return '0';
                    }
                }

            }

            // Apply rupee formatting for non-group rows
            // return params.value !== undefined && params.value !== null
            //     ? formatWithCommas(params.value)
            //     : params.value;
            return params.value !== undefined && params.value !== null
                ? (params.colDef.field === 'rt' ? `${params.value}` : formatWithCommas(params.value))
                : params.value;

        }

        // Return the default value for grouped rows
        return params.value;
    };


    const customCellRenderer2b = (params) => {
        console.log("params", params);
        console.log("params.node.level", params.node.level);

        const formatRupee = (value) => {
            if (value === undefined || value === null) return "";

            return new Intl.NumberFormat("en-IN", {
                style: "currency",
                currency: "INR",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            }).format(Math.round(value));
        };

        const formatWithCommas = (value) => {
            if (value === undefined || value === null) return "";

            return new Intl.NumberFormat("en-IN", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            }).format(Math.round(value));
        };

        const twobData = params.data["twob"];

        // Determine if `twob` contains an `items` array
        const childItems = Array.isArray(twobData?.items)
            ? twobData.items // Case 1: Extract `items` array
            : twobData && typeof twobData === "object"
                ? [twobData] // Case 2: Wrap `twob` object in an array
                : [];

        // console.log("Raw Data (params.data):", params.data);
        // console.log("twobData:", params.data["twob"]);
        // console.log("Child Items:", childItems);
        // console.log(
        //   `Checking '${params.colDef.field}' values in childItems:`,
        //   childItems.map((item) => item[params.colDef.field])
        // );


        if (!params.node.group && params.node.level === 0) {
            //const childItems = params.data["twob"]?.items || [];
            const mappedValues = childItems
                .map((item) => item[params.colDef.field])
                .filter(Boolean);


            if (params.colDef.field === "rt") {
                const uniqueValues = [...new Set(mappedValues)];
                if (uniqueValues.length === 1) {
                    const value = uniqueValues[0];
                    return value === 0 ? (
                        ""
                    ) : (
                        <Tag
                            color="green"
                            onClick={() => {
                                params.api.getFilterInstance("rt", (filterInstance) => {
                                    filterInstance.setModel({ type: "equals", filter: value });
                                    params.api.onFilterChanged();
                                });
                            }}
                        >{`${value}`}</Tag>
                    );
                } else if (uniqueValues.length > 1) {
                    return uniqueValues.map((value) => (
                        <Tag
                            key={value}
                            color="green"
                            onClick={() => {
                                params.api.getFilterInstance("rt", (filterInstance) => {
                                    filterInstance.setModel({ type: "equals", filter: value });
                                    params.api.onFilterChanged();
                                });
                            }}
                        >{`${value}`}</Tag>
                    ));
                } else {
                    return "";
                }
            } else {
                if (mappedValues.length === 1) {
                    return <strong>{formatWithCommas(mappedValues[0])}</strong>;
                } else if (mappedValues.length > 1) {
                    const sum = mappedValues.reduce(
                        (acc, val) => acc + (Number(val) || 0),
                        0
                    );
                    return <strong>{formatWithCommas(sum)}</strong>;
                } else {
                    return "0";
                }
            }
        }

        if (!params.node.group) {
            const groupData = params.node.groupData["ag-Grid-AutoColumn"];
            const twobData = params.data["twob"];//new--
            const childItems = Array.isArray(twobData?.items)//new----
                ? twobData.items // Case 1: Extract `items` array
                : twobData && typeof twobData === "object"
                    ? [twobData] // Case 2: Wrap `twob` object in an array
                    : [];

            if (/^[a-f0-9]{24}$/i.test(groupData)) {
                //const childItems = params.data["twob"]?.items || [];
                const mappedValues = childItems
                    .map((item) => item[params.colDef.field])
                    .filter(Boolean);

                if (params.colDef.field === "rt") {
                    const uniqueValues = [...new Set(mappedValues)];
                    if (uniqueValues.length === 1) {
                        const value = uniqueValues[0];
                        return value === 0 || value === "" ? (
                            ""
                        ) : (
                            <Tag
                                color="green"
                                onClick={() => {
                                    params.api.getFilterInstance("rt", (filterInstance) => {
                                        filterInstance.setModel({ type: "equals", filter: value });
                                        params.api.onFilterChanged();
                                    });
                                }}
                            >{`${value}`}</Tag>
                        );
                    } else if (uniqueValues.length > 1) {
                        return uniqueValues.map((value) => (
                            <Tag
                                key={value}
                                color="green"
                                onClick={() => {
                                    params.api.getFilterInstance("rt", (filterInstance) => {
                                        filterInstance.setModel({ type: "equals", filter: value });
                                        params.api.onFilterChanged();
                                    });
                                }}
                            >{`${value}`}</Tag>
                        ));
                    } else {
                        return "";
                    }
                } else {
                    if (mappedValues.length === 1) {
                        const value = mappedValues[0];
                        return value === 0 || value === "" ? (
                            ""
                        ) : (
                            <strong>{formatWithCommas(value)}</strong>
                        );
                    } else if (mappedValues.length > 1) {
                        const sum = mappedValues.reduce(
                            (acc, val) => acc + (Number(val) || 0),
                            0
                        );
                        return sum === 0 ? "" : <strong>{formatWithCommas(sum)}</strong>;
                    } else {
                        return "0";
                    }
                }
            }

            return params.value !== undefined && params.value !== null
                ? params.colDef.field === "rt"
                    ? `${params.value}`
                    : formatWithCommas(params.value)
                : params.value;
        }

        return params.value;
    };

    const [copiedText, setCopiedText] = useState("");

    const handleCopyData = (copyText) => {
        message.success({
            title: "Success",
            content: "Copied to clipboard!",
        });
        if (navigator.clipboard) {
            navigator.clipboard
                .writeText(copyText)
                .then(() => {
                    console.log("Text copied to clipboard");
                    messageApi.success({
                        title: "Success",
                        content: "Copied to clipboard!",
                    });
                    // setCopiedText(copyText); // Update copied text state
                    // Clear the "Copied" indicator after 2 seconds
                    setTimeout(() => setCopiedText(""), 2000);
                })
                .catch((err) => {
                    console.error("Failed to copy text: ", err);
                });
        } else {
            fallbackCopyTextToClipboard(copyText);
        }
    };

    function fallbackCopyTextToClipboard(text) {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();

        try {
            document.execCommand("copy");
            console.log("Text copied to clipboard");
            messageApi.success({
                title: "Success",
                content: "Copied to clipboard!",
            });
            // setCopiedText(text); // Update copied text state
            // setTimeout(() => setCopiedText(""), 2000); // Clear after 2 seconds
        } catch (err) {
            console.error("Failed to copy text: ", err);
        }

        document.body.removeChild(textArea);
    }

    const getServerSideDatasource = (followUpStatusValue, isSuccessMetric) => {
        console.log(activeTabView, "activeTabView")
        console.log("Inside server side function");
        const currentWorkspace = localStorage.getItem("currentWorkspace");

        return {
            getRows: async (gridParams) => {
                console.log(
                    "[Datasource] - rows requested by grid: ",
                    gridParams.request
                );
                console.log(workspace, "workspace");

                setCurrentTablePayload(gridParams.request);
                let lastestGroupedColumn =
                    gridParams.request.rowGroupCols &&
                    gridParams.request.rowGroupCols[gridParams.request.groupKeys.length];
                console.log(
                    "latest grouped:",
                    lastestGroupedColumn?.field,
                    gridParams.request
                );

                if (lastestGroupedColumn) {
                    setCurrentGrouped(lastestGroupedColumn.field);
                } else {
                    setCurrentGrouped("_id");
                }

                if (
                    gridParams.request.rowGroupCols.length ===
                    gridParams.request.groupKeys.length
                ) {
                    setCurrentGrouped("_id");
                }

                if (
                    gridParams.request.rowGroupCols.length <
                    gridParams.request.groupKeys.length
                ) {
                    const parentRowData = gridParams.parentNode?.data;
                    console.log("Parent Row Data:", parentRowData);

                    // Extracting item lists from different sources
                    const twoaItems = parentRowData?.["twoa"]?.itms || [];
                    const irnItems = parentRowData?.["irn"]?.ItemList || [];
                    const twobItems = parentRowData?.["twob"]?.items || [];

                    // Determine the maximum length
                    const maxLength = Math.max(
                        twoaItems.length,
                        irnItems.length,
                        twobItems.length
                    );
                    console.log("Max Length:", maxLength);

                    // Flatten the data based on max length
                    let flattenData = Array.from({ length: maxLength }, (_, index) => ({
                        _id: parentRowData?._id,
                        txval: twoaItems[index]?.itm_det?.txval ?? null,
                        iamt: twoaItems[index]?.itm_det?.iamt ?? null,
                        camt: twoaItems[index]?.itm_det?.camt ?? null,
                        rt: twoaItems[index]?.itm_det?.rt ?? null,
                        csamt: twoaItems[index]?.itm_det?.csamt ?? null,
                        samt: twoaItems[index]?.itm_det?.samt ?? null,

                        // IRN Data
                        IgstAmt: irnItems[index]?.IgstAmt ?? null,
                        CgstAmt: irnItems[index]?.CgstAmt ?? null,
                        SgstAmt: irnItems[index]?.SgstAmt ?? null,
                        AssAmt: irnItems[index]?.AssAmt ?? null,
                        GstRt: irnItems[index]?.GstRt ?? null,
                        HsnCd: irnItems[index]?.HsnCd ?? null,
                        MainHsnCode: irnItems[index]?.MainHsnCode ?? null,

                        // TWOB Data
                        // cess: twobItems[index]?.cess ?? null,
                        // cgst: twobItems[index]?.cgst ?? null,
                        // igst: twobItems[index]?.igst ?? null,
                        // sgst: twobItems[index]?.sgst ?? null,
                        cess: twobItems[index]?.cess ?? parentRowData?.twob?.cess ?? null,
                        cgst: twobItems[index]?.cgst ?? parentRowData?.twob?.cgst ?? null,
                        igst: twobItems[index]?.igst ?? parentRowData?.twob?.igst ?? null,
                        sgst: twobItems[index]?.sgst ?? parentRowData?.twob?.sgst ?? null,
                    }));

                    console.log("Flattened Data:", flattenData);
                    gridParams.success({ rowData: flattenData });
                } else {
                    console.log("active tab view check", activeTabView)
                    try {
                        const response = await fetch(
                            API_ENDPOINT_PREVIEW_VENDOR_TALLY,
                            // "http://localhost:7001/api/finalytics/tables/data/preview_vendor_tally",
                            {
                                method: "POST",
                                headers: { "Content-Type": "application/json" },
                                body: JSON.stringify({
                                    ...gridParams.request,
                                    database: "gstservice",
                                    table: "vendor_tally",
                                    workspace: currentWorkspace,
                                    FollowUp: selectedValue,
                                    filters: gridParams.request.filterModel,
                                    selectedMonth,
                                    ...(isSuccessMetric && { successMetrics: "true" }),
                                }),
                            }
                        );
                        console.log("params is:", gridParams);
                        const data = await response.json();
                        console.log(data, "data");
                        setTotalRowsCount(data.data.totalCount);

                        const modifiedData = data?.data?.rows?.map((item) => ({
                            ...item,
                            group: true,
                        }));
                        console.log("modifiedData", modifiedData);
                        gridParams.success({ rowData: modifiedData });
                    } catch (error) {
                        console.error("Error fetching server-side data:", error);
                        gridParams.fail();
                    }
                }
            },
        };
    };

    const getServerSideGroupKey = useCallback((dataItem) => dataItem._id, []);

    const onColumnRowGroupChanged = (params) => {
        console.log("Changes in onColumnRowGroupChanged");
        const groupedFields = params.columnApi
            .getRowGroupColumns()
            .map((col) => col.getColId());
        console.log(groupedFields, "groupedFields");
        setColumntCurrentGrouped(groupedFields);
    };



    const fetchUniqueVendorNames = async () => {
        const currentWorkspace = localStorage.getItem('currentWorkspace');
        const collection = 'vendor_tally'
        try {
            const response = await fetch(API_ENDPOINT_UNIQUE_VENDOR_TALLY, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },

                body: JSON.stringify({
                    collection: collection,
                    db: "gstservice",
                    currentWorkspace: currentWorkspace,
                }),
            });

            const data = await response.json();
            console.log(data, "unquie vendor name");
            if (data.success) {
                return data.data || [];
            } else {
                console.error("Failed to fetch vendor names:", data.message);
                return [];
            }
        } catch (error) {
            console.error("Error fetching vendor names:", error);
            return [];
        }
    };

    console.log(typeof vendorNames, "vendor Name");

    const isServerSideGroup = useCallback((dataItem) => dataItem.group, []);
    console.log("current grouped", currentGrouped);


    const renderMatchIcon = (params) => {
        if (params.node?.group || params.value === undefined) return null;

        const value = params.value === true || params.value === "True"; // Normalize to boolean

        return value ? (
            <CheckCircleFilled style={{ color: 'green', fontSize: '18px' }} />
        ) : (
            <CloseCircleFilled style={{ color: 'red', fontSize: '18px' }} />
        );
    };



    const columnDefs = useMemo(() => {
        console.log("Current activeTabView inside columnDefs:", activeTabView);


        const baseColumns = [{ // Vendor Details Heading
            headerName: "Supplier Details",
            children: [
                {
                    headerName: "Supplier Name",
                    field: "vendor_data.enablement_gov.tradeName",
                    width: 400,
                    cellStyle: { color: "#0A8394", textDecoration: "underline" },
                    // checkboxSelection: true, 
                    // headerCheckboxSelection: true,
                    columnGroupShow: "close",
                    onCellClicked: handleCellClick,
                    filter: "agSetColumnFilter",
                    floatingFilter: true,
                    //rowGroup:true,
                    filterParams: {
                        values: async (params) => {
                            console.log("Fetching vendor names for filter...");
                            try {
                                const vendorNames = await fetchUniqueVendorNames();
                                console.log("Fetched Vendor Names:", vendorNames);
                                params.success(vendorNames);
                            } catch (error) {
                                console.error("Error fetching vendor names:", error);
                                params.success([]);
                            }
                        },
                        suppressMiniFilter: false,
                        applyMiniFilterWhileTyping: true,
                    },


                },
                {
                    headerName: "Supplier GSTIN",
                    field: "vendor_data.vendor_gstin",
                    columnGroupShow: "close",
                    filter: "agTextColumnFilter",
                    floatingFilter: true,
                    cellRenderer: (params) => {
                        if (params.node?.group || params.value === undefined) return null;
                        if (params.node && !params.node.group) {
                            return <span>{params?.data?.vendor_data?.vendor_gstin}</span>;
                        }
                        const isCopied = copiedText === params?.data?.vendor_data?.vendor_gstin;
                        return (

                            <div>
                                <CopyOutlined
                                    style={{ marginRight: 6, cursor: "pointer" }}
                                    onClick={() =>
                                        handleCopyData(params?.data.vendor_data.vendor_gstin)
                                    }
                                />
                                <span>   {params?.data?.vendor_data?.vendor_gstin}</span>
                            </div>
                        )
                    }

                },
                {
                    headerName: "Enablement Status",
                    field: "einvoiceEligibility",
                    cellRenderer: renderEInvoice,
                    columnGroupShow: "close",
                    filter: "agSetColumnFilter", // Use AG Grid's set filter
                    filterParams: {
                        values: ["Eligible", "Not Eligible", "Exempted - Government", "Exempted - Manual"],
                        suppressMiniFilter: false, // Hides text search input
                        applyMiniFilterWhileTyping: true, // Enables filtering while typing
                    },
                    floatingFilter: true,
                },
                {
                    headerName: "Enablement Date",
                    field: "vendor_data.enablement_dt",
                    columnGroupShow: "open",
                    filter: "agDateColumnFilter",
                    // valueFormatter: (params) => {
                    //     const value = params.value;
                    //     if (value) {
                    //         const date = new Date(value);
                    //         return `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
                    //     }
                    //     return "No data available";
                    // },
                },
            ],
        },
        { // Buyer Details Heading
            headerName: "Buyer Details", // Group header for buyer details
            children: [
                {
                    headerName: "Buyer GSTIN",
                    field: "client_data.client_gstin",
                    columnGroupShow: "close",
                    filter: "agTextColumnFilter",
                    cellRenderer: (params) => {
                        if (params.node?.group || params.value === undefined) return null;
                        if (params.node && !params.node.group) {
                            return <span>{params?.data?.client_data?.client_gstin}</span>;
                        }
                        return (
                            <div>
                                <CopyOutlined
                                    style={{ marginRight: 6, cursor: "pointer" }}
                                    onClick={() =>
                                        handleCopyData(params?.data?.client_data?.client_gstin)
                                    }
                                />
                                <span>  {params?.data?.client_data?.client_gstin}</span>
                            </div>
                        )
                    }
                },
                {
                    headerName: "State",
                    valueGetter: (params) => {
                        const gstin = params?.data?.client_data?.client_gstin || "";
                        const stateCode = gstin.substring(0, 2);
                        return stateMapping[stateCode] || " ";
                    },
                    columnGroupShow: "open",
                    filter: false
                },
                {
                    headerName: "PAN",
                    field: "client_data.pan",
                    columnGroupShow: "open",
                    filter: "agTextColumnFilter"
                },
            ],
        },
        { // Invoice Details Heading
            headerName: "Invoice Details", // Group header for invoice-related columns
            children: [
                {
                    headerName: "Invoice Status",
                    field: "invoiceStatus",

                    // floatingFilter:true,
                    filter: "agSetColumnFilter",
                    filterParams: {
                        values: ["Invoice Received", "Invoice Not Received"],
                    },
                    columnGroupShow: "close",
                    valueGetter: (params) => {
                        return isSuccessMetric ? "Invoice Received" : params.data?.invoiceStatus;
                    },
                    cellRenderer: (params) => {
                        const { value } = params;
                        if (value === "Invoice Received") {
                            return <Tag color="green">{value}</Tag>;
                        } else if (value === "Invoice Not Received") {
                            return <Tag color="red">{value}</Tag>;
                        }
                        return value;
                    }


                },
                {
                    headerName: "Invoice Number",
                    field: "Doc_data.inum",
                    columnGroupShow: "open",
                    filter: "agTextColumnFilter",
                    cellRenderer: (params) => {
                        if (params.node?.group || params.value === undefined) return null;
                        if (params.node && !params.node.group) {
                            return <span>{params?.data?.Doc_data?.inum}</span>;
                        }
                        return (
                            <div>
                                <CopyOutlined
                                    style={{ marginRight: 6, cursor: "pointer" }}
                                    onClick={() =>
                                        handleCopyData(params?.data.Doc_data.inum)
                                    }
                                />
                                <span>   {params?.data?.Doc_data?.inum}</span>
                            </div>
                        )
                    }
                },
                // {
                //   headerName: "Invoice Link",
                //   field: "Doc_data.assetlink",
                //   columnGroupShow: "open",
                //   filter: false, // ✅ No filter required
                //   cellRenderer: (params) => {
                //     if (params.node && params.node.group) {
                //       // This ensures only parent rows are processed
                //       const hasAssetLink = params?.data?.Doc_data?.assetlink;
                //       const hasIrnFallback = params.data?.["irn-fallback"]?.irn_fallback_status === 'Present';
                //       const hasIrnData = params.data?.["irn"];

                //       if (hasAssetLink) {
                //         return (
                //           <p
                //             onClick={() => window.open(params.data?.Doc_data.assetlink, "_blank")}
                //             style={{
                //               color: "#0A8394",
                //               display: "flex",
                //               alignItems: "center",
                //               justifyContent: "center",
                //               gap: "5px",
                //               fontSize: "18px",
                //               cursor: "pointer",
                //             }}
                //           >
                //             <img src={invoicepng} className="invoiceimg" alt="Invoice" />
                //             Show Invoice
                //           </p>
                //         );
                //       } else if (hasIrnFallback && !hasIrnData) {
                //         return <span style={{ color: "orange" }}>IRN Generated, Copy Missing</span>;
                //       } else {
                //         return <span style={{ color: "red" }}>No Invoice Generated</span>;
                //       }

                //     }

                //     return ""; // Ensures nothing is rendered for child rows
                //   }


                // },

                {
                    field: "assetlink",
                    headerName: "Invoice Link",
                    columnGroupShow: "open",
                    filter: false,
                    cellRenderer: (params) => {
                        console.log("Checking---", params);
                        console.log("In invoiceLink", params?.data?.Doc_data?.assetlink)

                        if (params.node && !params.node.group && params?.data?.Doc_data?.assetlink === undefined) {
                            return null; // Ensure it doesn't render in group rows
                        }


                        if (params.node && !params.node.group) {
                            //console.log("Checking--", params);
                            const hasAssetLink = params.data?.Doc_data?.assetlink;
                            const hasIrnFallback =
                                params.data?.["irn-fallback"]?.irn_fallback_status === "Present";
                            const hasIrnData = params.data?.["irn"];

                            console.log(hasIrnFallback, "hasIrnFallback"); // ✅ Safe access

                            if (hasAssetLink) {
                                return (
                                    <p
                                        onClick={() => window.open(params.data?.Doc_data?.assetlink, "_blank")}
                                        style={{
                                            color: "#0A8394",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: "5px",
                                            fontSize: "18px",
                                            cursor: "pointer",
                                        }}
                                    >
                                        <img src={invoicepng} className="invoiceimg" alt="Invoice" />
                                        Show Invoice
                                    </p>
                                );
                            } else if (hasIrnFallback && !hasIrnData) {
                                return (
                                    <span style={{ color: "orange", fontWeight: "bold" }}>
                                        IRN Generated, Copy Missing
                                    </span>
                                );
                            } else {
                                return (
                                    <span style={{ color: "#b16002", fontWeight: "bold" }}>
                                        No Invoice Generated
                                    </span>
                                );
                            }
                        }
                    },
                },
                {
                    headerName: "Invoice Type",
                    field: "Doc_data.invType",
                    columnGroupShow: "open",
                    filter: "agSetColumnFilter",
                    floatingFilter: true,
                    valueFormatter: (params) => {
                        const typeMap = {
                            INV: "Invoice",
                            CRN: "Credit Note",
                            DBN: "Debit Note",
                        };
                        return typeMap[params.value] || params.value; // Default to original value if not mapped
                    },
                    filterParams: {
                        values: (params) => {
                            params.success(["INV", "CRN", "DBN"]); // Filter should recognize original values
                        },
                        valueFormatter: (params) => {
                            const typeMap = {
                                INV: "Invoice",
                                CRN: "Credit Note",
                                DBN: "Debit Note",
                            };
                            return typeMap[params.value] || params.value;
                        },
                    },
                    cellRenderer: (params) => {
                        // Hide content for child rows
                        if (params.node?.group || params.value === undefined) return null;

                        const typeMap = {
                            INV: { label: "Invoice", color: "geekblue" }, // Blue
                            CRN: { label: "Credit Note", color: "cyan" }, // Primary Blue
                            DBN: { label: "Debit Note", color: "purple" }, // Indigo
                        };

                        const type = typeMap[params.value] || { label: params.value, color: "#000" }; // Default to black if not found

                        return <Tag style={{ borderRadius: "5px" }} color={type.color}>{type.label}</Tag>;
                    },
                }
            ],
        },
        { // Amount Heading
            headerName: "Amount", // Group header for amount-related columns
            children: [
                {
                    headerName: "Total Amount",
                    field: "Amount_data.totalAmount",
                    aggFunc: 'sum',
                    valueFormatter: (params) => {
                        if (params.value !== undefined && params.value !== null) {
                            // Round the value and format it
                            const roundedValue = Math.round(params.value);
                            return new Intl.NumberFormat('en-IN', { minimumFractionDigits: 0 }).format(roundedValue);
                        }
                        return '';
                    },
                    cellStyle: () => ({
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                    }),
                    columnGroupShow: "close",
                    filter: "agNumberColumnFilter"
                },
                {
                    headerName: "Total Tax Value",
                    field: "Amount_data.totalTaxVal",
                    aggFunc: 'sum',
                    filter: "agNumberColumnFilter",
                    valueFormatter: (params) => {
                        if (params.value !== undefined && params.value !== null) {
                            // Round the value and format it
                            const roundedValue = Math.round(params.value);
                            return new Intl.NumberFormat('en-IN', { minimumFractionDigits: 0 }).format(roundedValue);
                        }
                        return '';
                    },
                    cellStyle: () => ({
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                    }),
                    columnGroupShow: "open"
                },
                {
                    headerName: "Total GST Amount",
                    field: "Amount_data.totalGstAmount",
                    filter: "agNumberColumnFilter",
                    aggFunc: 'sum',
                    valueFormatter: (params) => {
                        if (params.value !== undefined && params.value !== null) {
                            // Round the value and format it
                            const roundedValue = Math.round(params.value);
                            return new Intl.NumberFormat('en-IN', { minimumFractionDigits: 0 }).format(roundedValue);
                        }
                        return '';
                    },
                    cellStyle: () => ({
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                    }),


                    columnGroupShow: "open"
                },
                {
                    headerName: "Supplier liability",
                    field: "Amount_data.supplier_liability",
                    aggFunc: 'sum',
                    columnGroupShow: "open",
                    valueFormatter: (params) => {
                        if (params.value !== undefined && params.value !== null) {
                            // Round the value and format it
                            const roundedValue = Math.round(params.value);
                            return new Intl.NumberFormat('en-IN', { minimumFractionDigits: 0 }).format(roundedValue);
                        }
                        return '';
                    },
                    cellStyle: () => ({
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                    }),
                    filter: "agNumberColumnFilter",

                }
            ],
        },
        // Add aggregation function
        //{ headerName: "Doc Count", field: "docCount", aggFunc: 'sum', },  // Add aggregation function
        // {
        //   headerName: "CGST",
        //   field: "camt",
        //   valueGetter: (params) => {
        //     // Safely access and sum the `camt` values in the `itms` array
        //     const itms = params.data?.["twoa"]?.itms;
        //     if (Array.isArray(itms)) {
        //       return itms.reduce((sum, item) => sum + (item?.itm_det?.camt || 0), 0);
        //     }
        //     return 0;
        //   },
        //   aggFunc: 'sum',
        // },
        // {
        //   headerName: "SCST",
        //   field: "csamt",
        //   valueGetter: (params) => {
        //     // Safely access and sum the `csamt` values in the `itms` array
        //     const itms = params.data?.["twoa"]?.itms;
        //     if (Array.isArray(itms)) {
        //       return itms.reduce((sum, item) => sum + (item?.itm_det?.csamt || 0), 0);
        //     }
        //     return 0;
        //   },
        //   aggFunc: 'sum',
        // },
        // {
        //   headerName: "IGST",
        //   field: "iamt",
        //   valueGetter: (params) => {
        //     // Safely access and sum the `iamt` values in the `itms` array
        //     const itms = params.data?.["twoa"]?.itms;
        //     if (Array.isArray(itms)) {
        //       return itms.reduce((sum, item) => sum + (item?.itm_det?.iamt || 0), 0);
        //     }
        //     return 0;
        //   },
        //   aggFunc: 'sum',
        // },
        // {
        //   headerName: "Tax Rate",
        //   field: "rt",
        //   valueGetter: (params) => {
        //     // Safely access and return the first `rt` value in the `itms` array
        //     const itms = params.data?.["twoa"]?.itms;
        //     if (Array.isArray(itms) && itms.length > 0) {
        //       return itms[0]?.itm_det?.rt || 0;
        //     }
        //     return 0;
        //   },
        // },
        { headerName: "Id", field: "_id", hide: true, },
        { // Irn Details
            headerName: "Invoice Reference Number(IRN)",
            children: [
                // {
                //     headerName: "Irn Status",
                //     field: "invoiceStatus",
                //     filter: "agSetColumnFilter",
                //     cellRenderer: (params) => {
                //         if (params.node?.group || params.value === undefined) return null;

                //         let text = params.value;
                //         let color = "default";

                //         if (params.value === "Invoice Received" || params.value === true || params.value === "True") {
                //             text = "Present";
                //             color = "green";
                //         } else if (params.value === "Invoice Not Received") {
                //             text = "Missing";
                //             color = "red";
                //         }

                //         return <Tag color={color}>{text}</Tag>;
                //     },
                //     filterParams: {
                //         values: (params) => {
                //             params.success(["Invoice Received", "Invoice Not Received", true, "True"]); // Include true & "True" in filter options
                //         },
                //         valueFormatter: (params) => {
                //             if (params.value === "Invoice Received" || params.value === true || params.value === "True") {
                //                 return "Present";
                //             }
                //             return params.value === "Invoice Not Received" ? "Missing" : params.value;
                //         }
                //     }
                // },
                {
                    headerName: "Irn Status",
                    field: "invoiceStatus",
                    filter: "agSetColumnFilter",
                    cellRenderer: (params) => {
                        if (params.node?.group || params.value === undefined) return null;

                        let text = params.value;
                        let color = "default";

                        if (params.value === "Invoice Received") {
                            text = "Present";
                            color = "green";
                        } else if (params.value === "Invoice Not Received") {
                            text = "Missing";
                            color = "red";
                        }

                        return <Tag color={color}>{text}</Tag>;
                    },
                    // cellRenderer: (params) => {
                    //     if (params.node?.group || params.value === undefined) return null;

                    //     let text = params.value;
                    //     let color = "default";

                    //     if (params.value === "Invoice Received" || params.value === true || params.value === "True") {
                    //         text = "Present";
                    //         color = "green";
                    //     } else if (params.value === "Invoice Not Received") {
                    //         text = "Missing";
                    //         color = "red";
                    //     }

                    //     return <Tag color={color}>{text}</Tag>;
                    // },
                    // filterParams: {
                    //     values: (params) => {
                    //         params.success(["Invoice Received", "Invoice Not Received", true, "True"]); // Include true & "True" in filter options
                    //     },
                    //     valueFormatter: (params) => {
                    //         if (params.value === "Invoice Received" || params.value === true || params.value === "True") {
                    //             return "Present";
                    //         }
                    //         return params.value === "Invoice Not Received" ? "Missing" : params.value;
                    //     }
                    // }
                    filterParams: {
                        values: (params) => {
                            params.success(["Invoice Received", "Invoice Not Received"]); // Include true & "True" in filter options
                        },
                        valueFormatter: (params) => {
                            if (params.value === "Invoice Received") {
                                return "Present";
                            }
                            return params.value === "Invoice Not Received" ? "Missing" : params.value;
                        }
                    }
                },

                {
                    field: "HsnCd",
                    headerName: "HSN Code",
                    cellRenderer: customCellRendererIRN,
                    filter: false,
                    cellStyle: () => ({
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                    }),
                    columnGroupShow: "open"
                },
                {
                    field: "CgstAmt",
                    headerName: "Central GST Amount (INR)",
                    cellRenderer: customCellRendererIRN,
                    filter: false,
                    cellStyle: () => ({
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                    }),
                    columnGroupShow: "open"
                },
                {
                    field: "SgstAmt",
                    headerName: "State GST Amount (INR)",
                    cellRenderer: customCellRendererIRN,
                    filter: false,
                    cellStyle: () => ({
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                    }),
                    columnGroupShow: "open"
                },
                {
                    field: "IgstAmt",
                    headerName: "Integrated GST Amount (INR)",
                    cellRenderer: customCellRendererIRN,
                    filter: false,

                    cellStyle: () => ({
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                    }),
                    columnGroupShow: "open"
                },
                {
                    field: "AssAmt", headerName: "Assessable Amount (INR)", cellRenderer: customCellRendererIRN, filter: false,
                    cellStyle: () => ({
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                    }),
                    columnGroupShow: "open"
                },
                {
                    field: "GstRt",
                    headerName: "GST Rate (%)",
                    cellRenderer: customCellRendererIRN,
                    filter: false,
                    cellStyle: () => ({
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                    }),
                    columnGroupShow: "open"
                },
                {
                    field: "MainHsnCode",
                    headerName: "Main HSN Code",
                    cellRenderer: customCellRendererIRN,
                    filter: false,
                    cellStyle: () => ({
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                    }),
                    columnGroupShow: "open"
                },
                {
                    headerName: "Downloaded Date",
                    field: "irn.irn_scraped_dt",
                    filter: "agDateColumnFilter", // ✅ Enables date filtering
                    columnGroupShow: "open",
                    valueFormatter: (params) => {
                        const value = params.value;
                        if (value) {
                            const date = new Date(value);
                            return `${String(date.getDate()).padStart(2, "0")}/${String(
                                date.getMonth() + 1
                            ).padStart(2, "0")}/${date.getFullYear()}`;
                        }
                        return null;
                    },

                },



                // {
                //   headerName: "Irn Registered Date",
                //   columnGroupShow: "open",
                //   filter: "agTextColumnFilter",
                //   valueGetter: (params) => {
                //     const irnDt = params.data?.["irn"]?.IrnDt.toISOString;
                //     const docDt = params.data?.["irn"]?.DocDt.toISOString;
                //     return irnDt ?? docDt ?? null;
                //   }
                // }


            ],
        },
        { // 2A Details
            headerName: "2A",
            children: [


                // {
                //   headerName: "Filing period",
                //   field: "twoa.fp",  // Simple field name
                //   filter: "agTextColumnFilter",
                //   columnGroupShow: "open"
                // },
                {
                    headerName: "Filing period",
                    field: "fp",
                    filter: false,
                    columnGroupShow: "close",
                    valueFormatter: function (params) {
                        const value = params.value;
                        if (value && value.length === 6) {
                            // Display as "08-2024" from "082024"
                            return value.substring(0, 2) + '-' + value.substring(2);
                        }
                        return value;
                    },
                    filterValueGetter: function (params) {
                        // Ensure that filtering uses the raw value without a hyphen
                        const raw = params.data.twoa.fp;
                        return raw ? raw.replace(/-/g, '') : raw;
                    },
                    filterParams: {
                        textFormatter: function (value) {
                            // Remove hyphen from the user's filter input for filtering logic
                            return value ? value.toString().replace(/-/g, '') : value;
                        }
                    }
                },


                {
                    field: "txval", headerName: "Taxable Value (INR)", enableRowGroup: true,
                    cellRenderer: customCellRenderer,
                    filter: false,
                    cellStyle: () => ({
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                    }),
                    columnGroupShow: "open"
                },
                {
                    field: "iamt",
                    headerName: "Integrated GST (INR)",
                    cellRenderer: customCellRenderer,
                    filter: false,
                    cellStyle: () => ({
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                    }),
                    columnGroupShow: "open",

                },
                {
                    field: "camt",
                    headerName: "Central GST (INR)",
                    cellRenderer: customCellRenderer,
                    filter: false,
                    cellStyle: () => ({
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                    }),
                    columnGroupShow: "open"
                },
                {
                    field: "rt", headerName: "Tax Rate (%)",
                    cellRenderer: customCellRenderer,
                    filter: false,
                    cellStyle: () => ({
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                    }),
                    columnGroupShow: "open"
                },
                {
                    field: "csamt", headerName: "Cess Amount (INR)", cellRenderer: customCellRenderer,
                    filter: false,
                    cellStyle: () => ({
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                    }),
                    columnGroupShow: "open"
                },
                {
                    field: "samt", headerName: "State GST (INR)", cellRenderer: customCellRenderer,
                    filter: false,
                    cellStyle: () => ({
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                    }),
                    columnGroupShow: "open"
                },

                {
                    headerName: "Downloaded date",
                    field: "twoa.twoa_scraped_dt",
                    filter: "agDateColumnFilter",
                    columnGroupShow: "open",
                    valueFormatter: (params) => {
                        const value = params.value;
                        if (value) {
                            const date = new Date(value);
                            return `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
                        }
                        return "No data available";
                    },
                }


            ],
        },
        {
            // 2B Details
            headerName: "2B",
            children: [
                {
                    field: "cess",
                    headerName: "Cess Amount (INR)",
                    enableRowGroup: true,
                    filter: false,
                    cellRenderer: customCellRenderer2b,

                    columnGroupShow: "close",
                },
                {
                    field: "cgst",
                    headerName: "Central GST  (INR)",
                    filter: false,
                    cellRenderer: customCellRenderer2b,
                    cellStyle: () => ({
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                    }),
                    columnGroupShow: "open",
                },
                {
                    field: "igst",
                    headerName: "Integrated GST (INR)",
                    filter: false,
                    cellRenderer: customCellRenderer2b,
                    cellStyle: () => ({
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                    }),
                    columnGroupShow: "open",
                },
                {
                    field: "rt",
                    headerName: "Tax Rate (%)",
                    filter: false,
                    cellRenderer: customCellRenderer2b,
                    cellStyle: () => ({
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                    }),
                    columnGroupShow: "open",
                },
                {
                    field: "sgst",
                    headerName: "State GST (INR)",
                    filter: false,
                    cellRenderer: customCellRenderer2b,
                    cellStyle: () => ({
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                    }),
                    columnGroupShow: "open",
                },
                {
                    field: "txval",
                    headerName: "Taxable Value (INR)",
                    filter: false,
                    cellRenderer: customCellRenderer2b,
                    cellStyle: () => ({
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                    }),
                    columnGroupShow: "open",
                },

                {
                    headerName: "Downloaded date",
                    field: "twob.twob_scraped_dt",
                    filter: "agDateColumnFilter",
                    columnGroupShow: "open",
                    valueFormatter: (params) => {
                        const value = params.value;
                        if (value) {
                            const date = new Date(value);
                            return `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
                        }
                        return "No data available"; // ✅ Show message when value is missing
                    },
                }
            ],
        },
        {
            headerName: "2A Match",
            field: "match_status.twoa_status",
            cellRenderer: renderMatchIcon,
            filter: "agSetColumnFilter",
            filterParams: {
                values: ["True", "False"], // Correct way to specify filter values
            },

        },
        {
            headerName: "2B Match",
            field: "match_status.twob_status",
            cellRenderer: renderMatchIcon,
            filter: "agSetColumnFilter",
            filterParams: {
                values: ["True", "False"], // Correct way to specify filter values
            },

        },
        {
            headerName: "IRN Match",
            field: "match_status.irn_status",
            cellRenderer: renderMatchIcon,
            filter: "agSetColumnFilter",
            filterParams: {
                values: ["True", "False"], // Correct way to specify filter values
            },

        },
        {
            headerName: "Probability of Exemption",
            field: "exemption_percentage",
            filter: "agNumberColumnFilter",
            valueFormatter: (params) => {
                const value = params.value;
                return value !== undefined && value !== null ? Math.round(value) : "";
            }
        },
        // {
        //     headerName: "Email Logs",
        //     field: "email_open", // Reference field to trigger cellRenderer
        //     // hide: activeTabView != 2,
        //     cellRenderer: (params) => {

        //         if (!params.data) return null;

        //         // Transform the data into the expected format
        //         console.log(params.data, "params data in email logs")
        //         const eventData = mapEmailEvents(params.data);
        //         console.log(eventData, "eventData")

        //         // Call the function to render email event icons
        //         return handleRenderEmailEvents(eventData);
        //     },
        //     width: 200,
        // },


        {
            headerName: "FollowUp Detail", // Group header for follow-up related columns
            children: [
                {
                    headerName: "Follow-up",
                    field: "followUp",

                    enableRowGroup: true,
                    columnGroupShow: "close",
                    floatingFilter: true,
                    filter: 'agSetColumnFilter',
                    filterParams: {
                        values: ["Action Required", "No Action Required", "Action Taken"],
                    },
                    valueGetter: (params) => {
                        return isSuccessMetric ? "Action Taken" : params.data?.followUp;
                    },
                },
                {
                    headerName: "Follow-up Date",
                    // field: "followUpStatus",
                    field: "last_follow_up",
                    // filter: "agDateColumnFilter",
                    sortable: true,
                    // filter:"agTextColumnFilter",
                    enableRowGroup: true,
                    // cellRenderer: renderFollowUp1,
                    valueFormatter: (params) => {
                        const value = params.value;
                        if (value) {
                            const date = new Date(value);
                            return `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
                        }
                        return "No data available"; // ✅ Show message when value is missing
                    },
                    columnGroupShow: "open"
                },
                // {
                //     headerName: "Last Follow-up Reminder",
                //     field: "followUpStatus",
                //     sortable: true,
                //     enableRowGroup: true,
                //     cellRenderer: renderFollowUp2,
                //     columnGroupShow: "open",
                //     filter: "agTextColumnFilter",
                //     // filter: "agSetColumnFilter",
                //     // filterParams: {
                //     //     values: ["", "No Action Required", "Action Taken"],
                //     // },

                // },
                // {
                //     headerName: "Last Follow-up Reminder",
                //     field: "followUpStatus",
                //     sortable: true,
                //     enableRowGroup: true,
                //     cellRenderer: renderFollowUp2,
                //     columnGroupShow: "open",
                //     filter: "agTextColumnFilter",
                //     // filter: "agSetColumnFilter",
                //     // filterParams: {
                //     //     values: ["", "No Action Required", "Action Taken"],
                //     // },

                // },

                {
                    headerName: "Last Follow-up Reminder",
                    field: "lastFollowUpRemainder",
                    sortable: true,
                    enableRowGroup: true,
                    cellRenderer: renderFollowUp2,
                    columnGroupShow: "open",
                    filter: "agSetColumnFilter",
                    filterParams: {
                        values: Object.values(followUpStatusMapping), // ✅ This should now be safe
                    },
                    filterValueGetter: (params) => {
                        const { value, data } = params;

                        if (!value) return "No data available";
                        if (value === "request") return followUpStatusMapping.request;

                        const indexMap = {
                            sent: 0,
                            followUp1: 1,
                            followUp2: 2,
                            followUp3: 3,
                        };

                        const index = indexMap[value];
                        if (index !== undefined && data?.Email_logs?.length > index) {
                            return data.Email_logs[index]?.subject || followUpStatusMapping[value];
                        }

                        return followUpStatusMapping[value] || "No data available";
                    }
                }




            ],
        },
        {
            headerName: "Follow-up Status",
            field: "followUpStatus",
            sortable: true,
            enableRowGroup: true,
            // filter: "agTextColumnFilter",
            filter: "agSetColumnFilter", // Use agSetColumnFilter
            // filterParams: {
            //     values: ["sent", "Contact Missing", "No Action Required", "request"], // Define custom filter values

            // },

            filterParams: {
                values: [
                    "Contact Missing",
                    "No Action Required",
                    "request",
                    "sent",
                    "followUp1",
                    "followUp2"

                ],
                valueFormatter: (params) => {
                    const map = {
                        "Contact Missing": "Contact Missing",
                        "No Action Required": "No Action Required",
                        request: "Request",
                        sent: "Request Followup 1",
                        followUp1: "Request Followup 2",
                        followUp2: "Email Sent",

                    };
                    return map[params.value] || params.value;
                },
                keyCreator: (params) => {
                    const reverseMap = {
                        "Contact Missing": "Contact Missing",
                        "No Action Required": "No Action Required",
                        request: "request",
                        "Request Followup 1": "sent",
                        "Request Followup 2": "followUp1",
                        "Email Sent": "followUp2",
                    };
                    return reverseMap[params.value] || params.value;
                }
            },
            cellRenderer: renderFollowUp, // Link the renderFollowUp function here
            pinned: "right",
            onCellClicked: handleCellClick
        },

        ];
        if (activeTabView == 2) {
            baseColumns.push({
                headerName: "Email Logs",
                field: "email_open",
                width: 200,
                cellRenderer: (params) => {
                    if (!params.data) return null;
                    const eventData = mapEmailEvents(params.data);
                    return handleRenderEmailEvents(eventData);
                }
            });
        }
        return baseColumns
    }, [activeTabView]);
    const autoGroupColumnDef = useMemo(
        () => ({
            headerName: "Group",
            cellRenderer: "agGroupCellRenderer",
            floatingFilter: false,
            cellRendererParams: {
                suppressCount: true,
                innerRenderer: (params) => {
                    if (!params.node.group) {
                        return "Expand";
                    }

                    const groupField = params.node?.field;
                    const originalColumn = findColumnDefByField(columnDefs, groupField);

                    if (!originalColumn) return <div>{params?.value}</div>;

                    const nodeData = params?.value || params.data?.[originalColumn.field];
                    console.log(nodeData, "node data");
                    // const nodeData=params?.value || params.data.currentColumnGrouped

                    return (
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "100%",
                            }}
                        >
                            {nodeData}
                            {params.data?.count && (
                                <div style={{ marginLeft: 4 }}>({params.data.count})</div>
                            )}
                        </div>
                    );
                },
            },
        }),
        [currentGrouped, columnDefs]
    );


    // Add the following state to hold the selected rows count
    const [selectedRowsCount, setSelectedRowsCount] = useState(0);
    const [totalRowsCount, setTotalRowsCount] = useState(0);
    const [selectAllText, setSelectAllText] = useState("Select All");

    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
    const [selectedVendorData, setSelectedVendorData] = useState([]);



    const onSelectAllClick = async () => {
        console.log(userRole, "userRole");
        if (!gridApi) return; // Ensure gridApi is available

        if (selectAllText === "Request E-Invoice") {
            // Check if user is ADMIN
            if (userRole !== "ADMIN") {
                setAccessDeniedModalVisible(true); // Show access denied modal
                return;
            }

            try {

                const currentWorkspace = localStorage.getItem("currentWorkspace");

                const response = await fetch(
                    API_ENDPOINT_PREVIEW_VENDOR_TALLY,
                    {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                            filterModel: gridApi.getFilterModel(),
                            startRow: 0,
                            endRow: totalRowsCount,
                            database: "gstservice",
                            table: "vendor_tally",
                            workspace: currentWorkspace,
                            selectedMonth,
                            followUpStatus: "request",
                            rowGroupCols: [], // Added empty array for rowGroupCols
                            groupKeys: [],
                            pivotCols: []
                        })
                    }
                );

                const data = await response.json();
                const allRows = data.data.rows || [];
                setRequestCount(data.data.uniqueVendorCount)
                const vendorData = allRows
                    .map((row) => ({
                        vendorName: row?.vendor_data?.enablement_gov?.tradeName,
                        vendor_gstin: row?.vendor_data?.vendor_gstin
                    }))
                    .filter((item) => item.vendorName && item.vendor_gstin);

                setPopupVisible(true)
                if (vendorData.length > 0) {
                    setSelectedVendorData(vendorData);
                    setPopupVisible(true);
                }
            } catch (error) {
                console.error("Error fetching all rows:", error);
            }

            return;
        }

        // The remaining code handles select/deselect for grid rows
        const rowModelType = gridApi.getModel().getType();

        if (rowModelType === "clientSide") {
            const visibleNodes = [];
            gridApi.forEachNodeAfterFilterAndSort((node) => {
                visibleNodes.push(node);
            });

            const allVisibleRowsSelected = visibleNodes.every((node) =>
                node.isSelected()
            );

            if (allVisibleRowsSelected) {
                visibleNodes.forEach((node) => node.setSelected(false));
                setSelectAllText("Select All");
            } else {
                visibleNodes.forEach((node) => node.setSelected(true));
                setSelectAllText("Request E-Invoice");
            }
        } else if (rowModelType === "serverSide") {
            const selectedNodes = gridApi.getSelectedNodes();
            const allRowsSelected = selectedNodes.length > 0;

            if (allRowsSelected) {
                gridApi.deselectAll();
                setSelectAllText("Select All");
            } else {
                gridApi.selectAll();
                setSelectAllText("Request E-Invoice");
            }
        }
        setSelectedRowsCount(totalRowsCount);
    };



    const [vendorGstinList, setVendorGstinList] = useState([]); // State to store vendor and GSTIN list

    // Add a custom header to show the selected rows count
    const selectedRowsHeader = (
        <div>
            Selected Items: {selectedRowsCount}/{totalRowsCount}
        </div>
    );

    const closeSideMenu = () => {
        setIsSideMenuOpen(false); // Close the side menu
        // setSelectedVendor(null);
    };

    const [invoicesData, setInvoicesData] = useState({
        totalInvoices: 0,
        receivedInvoices: 0,
        notReceivedInvoices: 0,
        receivedPercentage: 0,
        notReceivedPercentage: 0,
    });

    const [totalGstAmount, setTotalGstAmount] = useState("");

    const calculateInvoiceData = (ctin) => {
        const invoicesForGstin = rowData.filter((row) => row.ctin === ctin);
        const totalInvoices = invoicesForGstin.length;
        const receivedInvoices = invoicesForGstin.filter(
            (row) => row.invoiceStatus === "Invoice Received"
        ).length;
        const notReceivedInvoices = invoicesForGstin.filter(
            (row) => row.invoiceStatus === "Invoice Not Received"
        ).length;
        const receivedPercentage =
            totalInvoices > 0 ? (receivedInvoices / totalInvoices) * 100 : 0;
        const notReceivedPercentage =
            totalInvoices > 0 ? (notReceivedInvoices / totalInvoices) * 100 : 0;
        return {
            totalInvoices,
            receivedInvoices,
            notReceivedInvoices,
            receivedPercentage,
            notReceivedPercentage,
        };
    };

    const detailColumnDefs = [
        { headerName: "HSN Code", field: "HsnCd" },
        { headerName: "HSN Description", field: "PrdDesc" },
    ];

    const getDetailRowData = (params) => {

        if (
            params.data &&
            params.data.Hsn_Irn &&
            Array.isArray(params.data.Hsn_Irn) &&
            params.data.Hsn_Irn.length > 0
        ) {
            params.successCallback(params.data.Hsn_Irn);
        } else {
            params.successCallback([]); // Ensure empty array is passed if no data found
        }
    };

    const [showPopup, setShowPopup] = useState(false);

    const handleFormSubmit = (e) => {
        e.preventDefault();

        const currentWorkspace = localStorage.getItem("currentWorkspace");

        // Prepare the form data to be sent to the backend
        const formData = {
            vendorValue,
            vendorGstin,
            contactName,
            contactEmail,
            contactNumber,
            roleType,
            workspace,
            currentWorkspace,
        };

        // Send the form data to the backend
        axios
            .post(API_ENDPOINT_ADD_CONTACT, formData)
            .then((response) => {
                closeModal();
                setShowPopup(true);
            })
            .catch((error) => {
                console.error("Error adding contact:", error);
            });
    };

    useEffect(() => {
        if (selectedWorkspace) {
            sessionStorage.setItem("selectedWorkspace", selectedWorkspace);
            setWorkspace(selectedWorkspace);
        }
    }, [selectedWorkspace]);


    function renderEInvoice(params) {
        if (isSuccessMetric) {
            return (
                <span className="eligiblestatus">
                    <span className="dot green"></span> Eligible
                </span>
            );
        }

        if (params.value === "Eligible" && params.data?.vendor_data?.exemptionStatus !== true) {
            return (
                <span className="eligiblestatus">
                    <span className="dot green"></span> Eligible
                </span>
            );
        } else if (params.value === "Not Eligible") {
            return (
                <span className="eligiblestatus">
                    <span className="dot red"></span> Not Eligible
                </span>
            );
        } else if (params.value === "Exempted") {
            return (
                <span className="eligiblestatus">
                    <span className="dot orange"></span> Exempted - Government
                </span>
            );
        } else if (
            params.data?.exemptionStatus === true ||
            params.data?.vendor_data?.exemptionStatus === true
        ) {
            return (
                <span className="eligiblestatus">
                    <span className="dot orange"></span> Exempted - Manual
                </span>
            );
        }
        return null; // Default case when value is not one of the above
    }

    const onGridReady = (params) => {
        gridRef.current = params;
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);

    };

    const gridOptions = useMemo(
        () => ({
            getRowStyle: (params) => {
                if (!params.data) return null;

                return params.data.ctin === selectedRowId
                    ? { backgroundColor: "#D3E9F7" }
                    : null;
            },
            serverSideSortingAlwaysResets: false,
            serverSideFilteringAlwaysResets: false,
            cacheBlockSize: 100,
            maxBlocksInCache: 5,
            animateRows: true,
            sideBar: {
                toolPanels: [
                    {
                        id: "columns",
                        labelDefault: "Columns",
                        labelKey: "columns",
                        iconKey: "columns",
                        toolPanel: "agColumnsToolPanel",
                        minWidth: 225,
                        maxWidth: 225,
                        width: 225,
                    },
                    {
                        id: "filters",
                        labelDefault: "Filters",
                        labelKey: "filters",
                        iconKey: "filter",
                        toolPanel: "agFiltersToolPanel",
                        minWidth: 180,
                        maxWidth: 400,
                        width: 250,
                    },
                    // {
                    //     id: "pdf viewer",
                    //     labelDefault: "View",
                    //     labelKey: "view",
                    //     iconKey: "pdfIcon",
                    //     toolPanel: "agFiltersToolPanel",
                    //     minWidth: 180,
                    //     maxWidth: 400,
                    //     width: 250,
                    // },
                ],
                position: "right",
            },

            icons: {
                pdfIcon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M10.377 11.2188L10.3828 11.1914C10.4961 10.7246 10.6387 10.1426 10.5273 9.61523C10.4531 9.19922 10.1465 9.03711 9.88477 9.02539C9.57617 9.01172 9.30078 9.1875 9.23242 9.44336C9.10352 9.91211 9.21875 10.5527 9.42969 11.3691C9.16406 12.002 8.74023 12.9219 8.42969 13.4688C7.85156 13.7676 7.07617 14.2285 6.96094 14.8105C6.9375 14.918 6.96484 15.0547 7.0293 15.1777C7.10156 15.3145 7.2168 15.4199 7.35156 15.4707C7.41016 15.4922 7.48047 15.5098 7.5625 15.5098C7.90625 15.5098 8.46289 15.2324 9.20508 13.959C9.31836 13.9219 9.43555 13.8828 9.54883 13.8438C10.0801 13.6641 10.6309 13.4766 11.1289 13.3926C11.6797 13.6875 12.3066 13.877 12.7324 13.877C13.1543 13.877 13.3203 13.627 13.3828 13.4766C13.4922 13.2129 13.4395 12.8809 13.2617 12.7031C13.0039 12.4492 12.377 12.3828 11.4004 12.5039C10.9199 12.2109 10.6055 11.8125 10.377 11.2188ZM8.23438 14.1855C7.96289 14.5801 7.75781 14.7773 7.64648 14.8633C7.77734 14.623 8.0332 14.3691 8.23438 14.1855ZM9.94531 9.58594C10.0469 9.75977 10.0332 10.2852 9.95508 10.5508C9.85938 10.1621 9.8457 9.61133 9.90234 9.54688C9.91797 9.54883 9.93164 9.56055 9.94531 9.58594ZM9.91406 11.9395C10.123 12.3008 10.3867 12.6113 10.6777 12.8418C10.2559 12.9375 9.87109 13.0957 9.52734 13.2363C9.44531 13.2695 9.36523 13.3027 9.28711 13.334C9.54688 12.8633 9.76367 12.3301 9.91406 11.9395ZM12.9531 13.2188C12.9551 13.2227 12.957 13.2285 12.9453 13.2363H12.9414L12.9375 13.2422C12.9219 13.252 12.7617 13.3457 12.0723 13.0742C12.8652 13.0371 12.9512 13.2168 12.9531 13.2188ZM16.6914 5.63672L12.4883 1.43359C12.3711 1.31641 12.2129 1.25 12.0469 1.25H3.75C3.4043 1.25 3.125 1.5293 3.125 1.875V18.125C3.125 18.4707 3.4043 18.75 3.75 18.75H16.25C16.5957 18.75 16.875 18.4707 16.875 18.125V6.08008C16.875 5.91406 16.8086 5.75391 16.6914 5.63672ZM15.4336 6.36719H11.7578V2.69141L15.4336 6.36719ZM15.4688 17.3438H4.53125V2.65625H10.4297V6.875C10.4297 7.09256 10.5161 7.30121 10.67 7.45505C10.8238 7.60889 11.0324 7.69531 11.25 7.69531H15.4688V17.3438Z" fill="black" fill-opacity="0.45"/>
      </svg>`,
            },
        }),
        []
    );


    const [isUploadContactsModalOpen, setUploadContactsModalOpen] =
        useState(false);

    const openUploadContactsModal = () => {
        if (userRole !== "ADMIN") {
            setAccessDeniedModalVisible(true);
            return;
        }
        setUploadContactsModalOpen(true);
    };

    const closeUploadContactsModal = () => setUploadContactsModalOpen(false);

    const handleSubmitFile = (file) => {
        console.log("File submitted:", file);
        const updatedVendorData = rowData.map((vendor) => {
            const match = file.data.find(
                (row) =>
                    vendor.ctin === row.ctin &&
                    vendor.enablement?.legalNm === row.vendorName
            );
            if (match) {

                if (vendor.contact !== "Completed") {
                    return { ...vendor, contact: "Completed" };
                }
            }
            return vendor;
        });

        toast.success("Thank You For Adding Contact", {
            position: "top-center",
            className: "center-toast",
        });
        setRowData(updatedVendorData);
        setContactData((prevContactData) => [...prevContactData, ...file.data]);
        setUploadContactsModalOpen(false);
    };
    const handleRoleChange = (e) => {
        setRoleType(e.target.value);
    };


    const [isAccessDeniedModalVisible, setAccessDeniedModalVisible] =
        useState(false);

    function findColumnDefByField(columnDefs, field) {
        let result = null;

        // Function to recursively search for the column definition
        function search(columns) {
            for (const column of columns) {
                if (column.field === field) {
                    result = column;
                    return; // Stop searching once we find the column
                }
                // Recursively search children
                if (column.children) {
                    search(column.children);
                }
            }
        }

        search(columnDefs);
        return result;
    }

    const handleCellDoubleClick = (event) => {

        const { colDef, value, api } = event; // Get column and value

        if (!value) return; // If value is empty, do nothing

        api.getFilterInstance(colDef.field, (filterInstance) => {
            if (filterInstance) {
                if (colDef.filter === "agSetColumnFilter") {
                    filterInstance.setModel({
                        values: [value],
                    });
                } else {
                    filterInstance.setModel({
                        type: "equals",
                        filter: value,
                    });
                }

                api.onFilterChanged();
            }
        });
    };




    const loadGridView2 = async (viewConfig = null, viewId) => {
        const columnApi = gridRef.current.columnApi;
        const gridApi = gridRef.current.api;
        if (!viewConfig || !gridApi) return;
        gridApi.resetColumnState();  // Reset column state
        gridApi.setFilterModel({});  // Remove all filters
        gridApi.setRowGroupColumns([]);  // Remove row grouping
        gridApi.setPivotColumns([]);  // **Ensure NO pivot columns exist**
        gridApi.setValueColumns([]);  // **Remove all aggregation columns**
        gridApi.setPivotMode(false);  // **Disable Pivot Mode**
        columnApi.applyColumnState({
            state: gridApi.getColumnState().map(col => ({ colId: col.colId, pivot: false, aggFunc: null })),
            applyOrder: false,
        });
        if (viewConfig === "DEFAULT") {
            gridApi.applyColumnState({
                state: initialColumnState,
                applyOrder: false,
            });
            setLoadingView(false);
            return;
        }
        columnApi.setPivotColumns(viewConfig.pivotCols?.map(item => item.field) || []);
        columnApi.setValueColumns(viewConfig.valueCols?.map(item => item.field) || []);
        const rowGroupCols = (viewConfig.rowGroupCols || []).map(item => ({
            colId: item.field || item.id,
            rowGroup: true,
        }));
        columnApi.applyColumnState({
            state: rowGroupCols,
            applyOrder: true,
        });
        if (viewConfig.filterModel) {
            console.log(viewConfig, "Inside load grid view")
            gridApi.setFilterModel(viewConfig.filterModel);
        }
        console.log(gridApi.setFilterModel(viewConfig.filterModel), "Inside load grid view")
        const sortModelMap = new Map((viewConfig.sortModel || []).map(sort => [sort.colId, sort.sort]));
        const updatedColumnState = gridApi.getColumnState().map(column => {
            if (sortModelMap.has(column.colId)) {
                return { ...column, sort: sortModelMap.get(column.colId) };
            }
            return column;
        });
        gridApi.applyColumnState({
            state: updatedColumnState,
            applyOrder: true,
        });
        gridApi.setPivotMode(viewConfig.pivotMode === true);
    };



    const [showCreateDiv, setShowCreateDiv] = useState(true);
    const [showSaveView, setShowSaveView] = useState(false);
    const [createMode, setCreateMode] = useState(false);
    const [currentTablePayload, setCurrentTablePayload] = useState(null);
    const [dynamicViews, setDynamicViews] = useRecoilState(tableDynamicViews);

    useEffect(() => {
        if (activeTabView === 0) {
            loadGridView2("DEFAULT");
        }

        else {
            loadGridView2(dynamicViews[activeTabView]?.viewConfig);
        }
    }, [activeTabView]);
    const filteredViews = isSuccessMetric
        ? (dynamicViews || []).filter(view => view.viewName === "Success Metrics")
        : dynamicViews;


    useEffect(() => {
        fetchDynamicViews();
    }, []);
    const fetchDynamicViews = async () => {
        const response = await apiGet(API_ENDPOINT_BHILOSA_VIEWS);
        if (response.status) {
            setDynamicViews([
                {
                    viewName: "All Data",
                    viewConfig: "DEFAULT",
                },
                ...response.data,
            ]);
        }
    };

    const createDynamicViews = async (payload) => {
        const response = await apiPost(API_ENDPOINT_BHILOSA_VIEWS, payload);
        if (response.status) {
            fetchDynamicViews();
        }
    };

    const handleStartSavingView = () => {
        message.info("Please start making your changes on table and click on save");
        setCreateMode(true);
    };

    const handleSaveTableView = () => {
        console.log("save");
        setIsModalVisible(true);
    };

    const handleConfirmSave = () => {
        const viewData = {
            viewName: tableName,
            viewConfig: currentTablePayload,
        };
        // setDynamicViews([...dynamicViews, viewData]);
        createDynamicViews(viewData);

        console.log("get table payload", viewData);
        setCreateMode(false);
        setIsModalVisible(false);
    };

    const handleCloseModal = () => {
        setIsModalVisible(false);
    };

    return (
        <>
            {/* <Navbar/> */}
            <div style={{ display: "flex" }}>
                <div>
                    <PrimaryNavBhilosa />
                </div>
                <div style={{ width: "100%", height: "100vh" }}>
                    <div style={{ marginBottom: "20px" }}>
                        <AccessDeniedModal
                            isVisible={isAccessDeniedModalVisible}
                            onClose={() => setAccessDeniedModalVisible(false)}
                        />
                        {showPopup && (
                            <ContactPopup
                                message="Contact Added Successfully!"
                                emoji="🎉"
                                onClose={() => setShowPopup(false)}
                            />
                        )}
                        <div className="vendor-header">
                            <div className="vendor-header-left">
                                <div>
                                    {/* <button className="vendor-back-btn" onClick={goBack}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                        >
                                            <path
                                                d="M17.0305 10.7422L5.60281 10.7422L12.4427 16.6797C12.552 16.7754 12.4856 16.9531 12.3411 16.9531H10.6126C10.5364 16.9531 10.4641 16.9258 10.4075 16.877L3.02664 10.4727C2.95904 10.4141 2.90482 10.3416 2.86767 10.2602C2.83051 10.1789 2.81128 10.0904 2.81128 10.001C2.81128 9.91151 2.83051 9.8231 2.86767 9.74172C2.90482 9.66034 2.95904 9.58789 3.02664 9.5293L10.4505 3.08594C10.4798 3.06055 10.5149 3.04688 10.552 3.04688L12.3391 3.04687C12.4837 3.04687 12.5501 3.22656 12.4407 3.32031L5.60281 9.25781L17.0305 9.25781C17.1165 9.25781 17.1868 9.32812 17.1868 9.41406V10.5859C17.1868 10.6719 17.1165 10.7422 17.0305 10.7422Z"
                                                fill="#0A8394"
                                            />
                                        </svg>
                                    </button> */}
                                </div>

                                <h1
                                    style={{
                                        color: "#3F4047",
                                        fontWeight: "500",
                                        margin: "20px 5px",
                                    }}
                                >
                                    {isSuccessMetric ? "Success Metric table" : "Follow up table"}
                                </h1>

                                {/* <div style={{ color: '#0A8394', fontWeight: '500', margin: '20px 0px' }} >{selectedRowsHeader}</div> */}
                                {activeTab === "Action Required" && (
                                    <div
                                        style={{
                                            color: "#0A8394",
                                            fontWeight: "500",
                                            margin: "20px 0px",
                                        }}
                                    >
                                        {selectedRowsHeader}
                                    </div>
                                )}
                            </div>

                            <div className="vendor-right">
                                {!isSuccessMetric && (
                                    <button
                                        onClick={openUploadContactsModal}
                                        className="vendor-btn"
                                    >
                                        <PlusOutlined /> <p> Add Contact</p>
                                    </button>
                                )}


                                {activeTabView == 1 && (
                                    <button
                                        onClick={onSelectAllClick}
                                        style={{ padding: "5px 10px", marginRight: "10px" }}
                                        className="groupby-btn"
                                    >
                                        {selectAllText === "Select All" ? (
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="25"
                                                height="24"
                                                viewBox="0 0 25 24"
                                                fill="none"
                                            >
                                                <path
                                                    d="M7.75 12L12.75 17L22.75 7M2.75 12L7.75 17M12.75 12L17.75 7"
                                                    stroke="white"
                                                    strokeWidth="1.33333"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        ) : (
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="25"
                                                height="24"
                                                viewBox="0 0 25 24"
                                                fill="none"
                                            >
                                                <path
                                                    d="M10.75 14L21.75 3M10.75 14L14.25 21C14.2939 21.0957 14.3643 21.1769 14.453 21.2338C14.5416 21.2906 14.6447 21.3209 14.75 21.3209C14.8553 21.3209 14.9584 21.2906 15.0471 21.2338C15.1357 21.1769 15.2061 21.0957 15.25 21L21.75 3M10.75 14L3.75001 10.5C3.65427 10.4561 3.57314 10.3857 3.51626 10.2971C3.45938 10.2084 3.42914 10.1053 3.42914 10C3.42914 9.89469 3.45938 9.79158 3.51626 9.70295C3.57314 9.61432 3.65427 9.54388 3.75001 9.5L21.75 3"
                                                    stroke="white"
                                                    strokeWidth="1.33333"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        )}
                                        {selectAllText}
                                    </button>
                                )}


                                {isPopupVisible && <ConfirmationPopup
                                    onClose={handlePopupClose}
                                    onConfirm={handlePopupConfirm}
                                    totalCount={requestCount}
                                />}
                                {/* <button className="remove-filter" onClick={clearFilters}>Remove Filter</button> */}

                                {/* <button onClick={applyRowGrouping} style={{ padding: "5px 10px" }} className="groupby-btn">
    Group by Vendor Name
  </button> */}
                            </div>
                        </div>

                        {loading && (
                            <div
                                style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    backgroundColor: "rgba(255, 255, 255, 0.8)",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    zIndex: 10,
                                }}
                            >
                                <ClipLoader color="#36D7B7" size={50} />
                            </div>
                        )}
                        {/* <div style={{ display: 'flex', gap: '15px', marginBottom: '5px' ,fontSize:'14px' ,color:'#0a8394',marginTop:'10px',marginLeft:'12px',cursor:'pointer',fontWeight: '700'}}>
                            <div type="primary" >All Data</div>
                            <div
                                type="primary"
                                
                                onClick={() => loadGridView2(hardcodedData)}
                            >
                                Action Required

                            </div>

                            <div type="primary"  onClick={() => loadGridView2(hardcodedData)}>No Action Required</div>
                            <div type="primary"  onClick={() => loadGridView2(hardcodedData)}>Action Taken</div>
                            {showCreateDiv ? (
                <div 
                    type="primary" 
                    //style={{ width: '120px', backgroundColor: '#007bff', color: 'white', padding: '10px', textAlign: 'center', borderRadius: '5px', cursor: 'pointer' }} 
                    onClick={() => {
                        setShowCreateDiv(false);
                        setShowSaveView(true);
                    }}
                >
                    Create
                </div>
            ) : showSaveView && (
                <div style={{display:'flex',gap: '10px' }}>
                    <div >
                        Save
                    </div>
                    <div >
                        View
                    </div>
                </div>
            )}
                        </div> */}
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <Tabs
                                defaultActiveKey={activeTabView}
                                type="line"
                                //onChange={(item) => setActiveTabView(item)}
                                onChange={(key) => {
                                    setActiveTabView(key);

                                }}
                                style={{ marginLeft: "12px", marginTop: "10px" }}
                            >
                                {/* {(dynamicViews || []).map((item, key) => {
                                    return <Tabs.TabPane key={key} tab={item.viewName} />;
                                })} */}
                                {(filteredViews || []).map((item, key) => {
                                    return <Tabs.TabPane key={key} tab={item.viewName} />;
                                })}
                                {/* <Tabs.TabPane key="action-required" tab="Action Required" />
                <Tabs.TabPane key="no-action-required" tab="No Action Required" /> */}
                            </Tabs>
                            {!isSuccessMetric && (
                                createMode ? (
                                    <>
                                        <Button
                                            size="small"
                                            icon={<CheckCircleFilled />}
                                            style={{ marginLeft: 12, marginBottom: 4 }}
                                            type="primary"
                                            onClick={handleSaveTableView}
                                        >
                                            Save
                                        </Button>
                                        <Button
                                            size="small"
                                            icon={<CloseCircleOutlined />}
                                            style={{ marginLeft: 12, marginBottom: 4 }}
                                            onClick={() => setCreateMode(false)}
                                        >
                                            Cancel
                                        </Button>
                                    </>
                                ) : (
                                    <Button
                                        size="small"
                                        icon={<PlusOutlined />}
                                        style={{ marginLeft: 20, marginBottom: 4 }}
                                        type="primary"
                                        onClick={handleStartSavingView}
                                    >
                                        Create View
                                    </Button>
                                )
                            )}
                        </div>
                        {isModalVisible && (
                            <Modal
                                isOpen={isModalVisible}
                                onRequestClose={() => setIsModalVisible(false)}
                                style={{
                                    content: {
                                        width: "400px",
                                        height: "180px",
                                        margin: "auto",
                                        borderRadius: "8px",
                                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                        border: "1px solid #ddd",
                                        padding: "30px",
                                    },
                                    overlay: {
                                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                                    },
                                }}
                            >
                                <div>
                                    <div className="modalHeading">
                                        <div className="tableHeading">Table View</div>
                                        <div onClick={handleCloseModal} className="closeModal">
                                            <CloseOutlined style={{ color: "#0a8394" }} />
                                        </div>
                                    </div>

                                    <div className="inputPortion">
                                        <label className="table-name">Table Name</label>
                                        <Input
                                            className="userTable-name"
                                            value={tableName}
                                            onChange={(e) => setTableName(e.target.value)}
                                            placeholder="Enter table name here"
                                        />
                                    </div>
                                    <div className="modalBtn">
                                        <Button
                                            style={{ borderColor: "#0a8394", color: "#0a8394" }}
                                            onClick={handleCloseModal}
                                        >
                                            Cancel
                                        </Button>
                                        <Button type="primary" onClick={handleConfirmSave}>
                                            Save
                                        </Button>
                                    </div>
                                </div>
                            </Modal>
                        )}

                        <div
                            className="ag-theme-alpine"
                            style={{
                                height: "89vh",
                                marginRight: "15px",
                                marginLeft: "10px",
                            }}
                        >
                            <AgGridReact
                                // rowData={rowData}
                                ref={gridRef}
                                onCellDoubleClicked={handleCellDoubleClick}//new
                                columnDefs={columnDefs}
                                onColumnRowGroupChanged={onColumnRowGroupChanged}
                                defaultColDef={defaultColDef}
                                groupDefaultExpanded={-1}
                                gridOptions={gridOptions}
                                rowGroupPanelShow="always"
                                rowSelection="multiple"
                                rowModelType="serverSide"
                                onGridReady={onGridReady}
                                suppressRowClickSelection={true}
                                onColumnChanged={(params) => console.log("column changed", params)}
                                // onRowGroupOpened={onRowGroupOpened}  
                                enableSorting={true}
                                // enableFilter={true}
                                treeData={true}
                                getServerSideGroupKey={getServerSideGroupKey}
                                autoGroupColumnDef={autoGroupColumnDef}


                                isServerSideGroup={isServerSideGroup}

                                // masterDetail={true}
                                groupSelectsChildren={true}
                                paginationPageSize={500}
                                cacheBlockSize={500}
                                detailCellRendererParams={{
                                    detailGridOptions: {
                                        columnDefs: detailColumnDefs,
                                    },
                                    getDetailRowData: getDetailRowData,
                                }}

                                // floatingFilter={true}
                                getRowStyle={(params) => {//new
                                    return params.node.id === selectedRowId
                                        ? { backgroundColor: "#fbb75b", color: "black" } // Highlight the row
                                        : null;
                                }}

                            />
                        </div>
                        <EmailModal
                            isOpen={isEmailModalOpen}
                            onClose={closeEmailModal}
                            vendorData={modalVendorData}
                            onSend={handleSendInvite}
                            selectedTemplateId={selectedTemplateId}
                        />
                        <UploadContactsModal
                            isOpen={isUploadContactsModalOpen}
                            onClose={closeUploadContactsModal}
                            onSubmit={handleSubmitFile}
                            selectedVendorNamesAndGstin={vendorGstinList}
                            sampleCsvPath="/vendor_contact_details.csv"
                        />
                        {isEmailConfirmationModelOpen && (
                            <EmailConfirmationModel
                                onClose={() => setIsEmailConfirmationModelOpen(false)}
                            />
                        )}
                        {isSideMenuOpen && (
                            <div className="side-menu">
                                <button className="close-btn" onClick={closeSideMenu}>
                                    &times;
                                </button>
                                <MainContentVendor
                                    gstin={gstin}
                                    invoicesData={invoicesData}
                                    totalGstAmount={totalGstAmount}
                                    workspace={workspace_name}
                                />
                            </div>
                        )}
                        {isModalOpen && (
                            <Modal
                                isOpen={isModalOpen}
                                onRequestClose={closeModal}
                                style={{
                                    content: {
                                        width: "400px",
                                        height: "400px",
                                        margin: "auto",
                                        borderRadius: "8px",
                                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                        border: "1px solid #ddd",
                                        padding: "30px",
                                    },
                                    overlay: {
                                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                                    },
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                    }}
                                >
                                    <h2 style={{ marginBottom: "10px", fontWeight: "500" }}>
                                        Add {vendorValue} Contact
                                    </h2>
                                    <button
                                        onClick={closeModal}
                                        style={{
                                            background: "transparent",
                                            border: "none",
                                            fontSize: "18px",
                                            cursor: "pointer",
                                            color: "#0A8394",
                                        }}
                                    >
                                        ✕
                                    </button>
                                </div>
                                <form onSubmit={handleFormSubmit}>
                                    <div style={{ marginBottom: "15px" }}>
                                        <label
                                            style={{
                                                display: "block",
                                                fontWeight: "400",
                                                marginBottom: "5px",
                                                color: "#212121",
                                            }}
                                        >
                                            Name
                                        </label>
                                        <input
                                            type="text"
                                            value={contactName}
                                            onChange={(e) => setContactName(e.target.value)}
                                            placeholder="Enter name here"
                                            style={{
                                                width: "95%",
                                                padding: "8px",
                                                borderRadius: "4px",
                                                border: "1px solid #ccc",
                                                fontSize: "14px",
                                            }}
                                        />
                                    </div>

                                    <div style={{ marginBottom: "15px" }}>
                                        <label
                                            style={{
                                                display: "block",
                                                fontWeight: "400",
                                                marginBottom: "5px",
                                                color: "#212121",
                                            }}
                                        >
                                            Email Id
                                        </label>
                                        <input
                                            type="email"
                                            value={contactEmail}
                                            onChange={(e) => setContactEmail(e.target.value)}
                                            placeholder="Enter email address"
                                            style={{
                                                width: "95%",
                                                padding: "8px",
                                                borderRadius: "4px",
                                                border: "1px solid #ccc",
                                                fontSize: "14px",
                                            }}
                                        />
                                    </div>

                                    <div style={{ marginBottom: "15px" }}>
                                        <label
                                            style={{
                                                display: "block",
                                                fontWeight: "400",
                                                marginBottom: "5px",
                                                color: "#212121",
                                            }}
                                        >
                                            Contact number
                                        </label>
                                        <input
                                            type="text"
                                            value={contactNumber}
                                            onChange={(e) => setContactNumber(e.target.value)}
                                            placeholder="Enter number here"
                                            style={{
                                                width: "95%",
                                                padding: "8px",
                                                borderRadius: "4px",
                                                border: "1px solid #ccc",
                                                fontSize: "14px",
                                            }}
                                        />
                                    </div>
                                    {/* <div style={{ marginBottom: '15px' }}>
  <label style={{ display: 'block', fontWeight: '400', marginBottom: '5px', color: '#212121' }}>
    Role
  </label>
  <select
    value={roleType}  // Ensure the value is correctly bound to roleType
    onChange={handleRoleChange}  // Update the state when a new option is selected
    style={{
      width: '95%',
      padding: '8px',
      borderRadius: '4px',
      border: '1px solid #ccc',
      fontSize: '14px',
      backgroundColor: 'white',
    }}
  >
    <option value="" disabled>Choose a role</option>
    <option value="FINANCE">Finance</option>
    <option value="SALES_PERSON">Sales Person</option>
    <option value="RECRUITMENT">Recruitment</option>
    <option value="TAX_PERSON">Tax Person</option>
    <option value="ACCOUNTANT">Accountant</option>
    <option value="OTHERS">Others</option>
  </select>
</div>
 */}
                                    <div>
                                        <label
                                            htmlFor="role-select"
                                            style={{ display: "block", marginBottom: "8px" }}
                                        >
                                            Role
                                        </label>
                                        <select
                                            id="role-select"
                                            value={roleType}
                                            onChange={handleRoleChange}
                                            style={{
                                                backgroundColor: "white",
                                                padding: "8px 12px",
                                                border: "1px solid #ccc",
                                                borderRadius: "4px",
                                                width: "100%",
                                                color: "black",
                                                textAlign: "left", // Align the text to the left
                                            }}
                                        >
                                            <option value="" disabled>
                                                Choose a role
                                            </option>
                                            <option value="FINANCE">Finance</option>
                                            <option value="SALES_PERSON">Sales Person</option>
                                            <option value="RECRUITMENT">Recruitment</option>
                                            <option value="TAX_PERSON">Tax Person</option>
                                            <option value="ACCOUNTANT">Accountant</option>
                                            <option value="OTHERS">Others</option>
                                        </select>
                                    </div>

                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            marginTop: "20px",
                                            width: "100%",
                                        }}
                                    >
                                        <button
                                            type="button"
                                            onClick={closeModal}
                                            style={{
                                                padding: "10px 20px",
                                                background: "#fff",
                                                border: "1px solid #ccc",
                                                borderRadius: "4px",
                                                cursor: "pointer",
                                                width: "60%",
                                            }}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            style={{
                                                padding: "10px 20px",
                                                background: "#0A8394",
                                                color: "#fff",
                                                border: "none",
                                                borderRadius: "4px",
                                                cursor: "pointer",
                                                width: "60%",
                                                marginLeft: "10px",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                            }}
                                        >
                                            <svg
                                                xmlns="https://www.w3.org/2000/svg"
                                                width="21"
                                                height="18"
                                                viewBox="0 0 21 20"
                                                fill="none"
                                            >
                                                <path
                                                    d="M10.5001 4.16666V15.8333M4.66675 9.99999H16.3334"
                                                    stroke="white"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>{" "}
                                            Add
                                        </button>
                                    </div>
                                </form>
                            </Modal>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default VendorEInvoiceDataNew;
